var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--floor--inject-2",
    d: "M76.35,452.7c-95.9-55.37-95.9-145.14,0-200.51s251.39-55.37,347.3,0,95.9,145.14,0,200.51S172.25,508.07,76.35,452.7Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.94,400.17a.5.5,0,0,1-.17,0l-4.9-1.26a.46.46,0,0,1-.29-.27c-.05-.13-4.31-12.88,4.78-30.17,6.48-12.34,16.63-20.36,23.09-18.25a7.2,7.2,0,0,1,5,5.13,8.35,8.35,0,0,1-2.63,7.79c-.51.49-1.3,1.16-2.3,2-6.19,5.27-20.69,17.6-22.26,34.65a.46.46,0,0,1-.36.38Zm-4.63-2,4.2,1.08c1.82-17.13,16.29-29.44,22.5-34.72,1-.84,1.77-1.51,2.26-2a7.53,7.53,0,0,0,2.4-7,6.31,6.31,0,0,0-4.48-4.52c-6.09-2-15.79,5.86-22.09,17.84C446.84,384.59,449.81,396.43,450.31,398.14Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.16,399.45h-.06a.43.43,0,0,1-.43-.42c-.36-19.91,13.42-39.09,22.69-43a.42.42,0,0,1,.55.23.41.41,0,0,1-.22.55c-9.17,3.91-22.52,23.37-22.17,42.25A.43.43,0,0,1,452.16,399.45Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,398.91a.37.37,0,0,1-.18,0l-3.33-1a.43.43,0,0,1-.28-.28c-.06-.19-5.91-19.21-1.6-44.83,2.2-13,9.81-25.78,18.09-30.27,4-2.15,7.9-2.42,11.64-.8a6.4,6.4,0,0,1,3.93,4c1.37,4.85-3.66,12.06-9,19.7-3.73,5.35-7.58,10.88-9.34,15.76a.42.42,0,0,1-.54.25.42.42,0,0,1-.26-.54c1.8-5,5.69-10.56,9.45-16,5.21-7.47,10.13-14.53,8.87-19a5.48,5.48,0,0,0-3.46-3.48,11.92,11.92,0,0,0-10.89.77c-8.08,4.37-15.5,16.85-17.66,29.66-4,24,.88,42.08,1.51,44.23l3.1.93a.43.43,0,0,1,.28.53A.43.43,0,0,1,450,398.91Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.22,386.79h0a.43.43,0,0,1-.46-.39c-2.5-30.79,14.68-55.45,19.76-59.68a.42.42,0,1,1,.54.65c-5,4.17-21.93,28.5-19.45,59A.43.43,0,0,1,449.22,386.79Z",
    style: {
      fill: "#3B3355"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.06,425.29a.45.45,0,0,1-.18-.3c-1.56-17.05-16.06-29.38-22.26-34.65-1-.85-1.79-1.52-2.3-2a8.35,8.35,0,0,1-2.63-7.79,7.2,7.2,0,0,1,5-5.13c6.47-2.11,16.61,5.91,23.1,18.25,9.08,17.29,4.82,30,4.77,30.17a.42.42,0,0,1-.29.27l-4.9,1.26a.39.39,0,0,1-.35-.07Zm0-31.24c-6.3-12-16-19.82-22.09-17.84a6.28,6.28,0,0,0-4.47,4.52,7.49,7.49,0,0,0,2.4,7c.48.47,1.26,1.14,2.25,2,6.21,5.28,20.68,17.59,22.51,34.72l4.19-1.08C47.37,421.63,50.34,409.79,42.08,394.05Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,424.65h0a.42.42,0,0,0,.43-.42c.36-19.91-13.41-39.09-22.69-43a.42.42,0,0,0-.33.78c9.17,3.91,22.52,23.37,22.18,42.25A.41.41,0,0,0,45,424.65Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.14,424.11a.41.41,0,0,0,.19,0l3.32-1a.41.41,0,0,0,.28-.28c.06-.19,5.92-19.21,1.6-44.83-2.2-13.05-9.81-25.78-18.09-30.27a12.79,12.79,0,0,0-11.63-.8,6.39,6.39,0,0,0-3.94,4c-1.37,4.85,3.67,12.06,9,19.7,3.73,5.35,7.59,10.88,9.34,15.76a.43.43,0,0,0,.55.25.42.42,0,0,0,.25-.54c-1.8-5-5.68-10.56-9.44-15.95-5.21-7.47-10.13-14.53-8.87-19a5.49,5.49,0,0,1,3.45-3.48,11.94,11.94,0,0,1,10.9.77c8.07,4.37,15.5,16.85,17.66,29.66,4,24-.89,42.08-1.51,44.23l-3.11.93a.43.43,0,0,0-.28.53A.45.45,0,0,0,47.14,424.11Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48,412h0a.43.43,0,0,0,.46-.39c2.5-30.79-14.68-55.45-19.76-59.68a.41.41,0,0,0-.59.05.43.43,0,0,0,0,.6c5,4.17,21.93,28.5,19.46,59A.42.42,0,0,0,48,412Z",
    style: {
      fill: "#3B3355"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadows--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--Shadow--inject-2",
    d: "M287,306.44l-20-11.53a4.77,4.77,0,0,0-4.32,0L37.52,425a1.32,1.32,0,0,0,0,2.5l20.16,11.73a4.75,4.75,0,0,0,4.31,0l44.37-25.7a18.94,18.94,0,0,0,1.87,1.24l32.49,18.76a31.27,31.27,0,0,0,28.79,0l62.68-36.19c4.65-2.69,7.32-6.7,7.32-11s-2.67-8.31-7.32-11l-30-17.3L287,308.93A1.31,1.31,0,0,0,287,306.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M268.86,448.65c28-16.19,28-42.43,0-58.61s-73.49-16.19-101.52,0-28,42.43,0,58.61S240.83,464.83,268.86,448.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M452.15,436.28c24-13.84,24-36.28,0-50.12s-62.84-13.84-86.81,0-24,36.28,0,50.12S428.18,450.12,452.15,436.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-2",
    d: "M267.61,389.11l-41-23.64c-2-1.13-2-3,0-4.09L342.8,294.32a7.82,7.82,0,0,1,7.08,0L390.83,318c2,1.13,2,3,0,4.09L274.7,389.11A7.84,7.84,0,0,1,267.61,389.11Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-box--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-box--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.53,364.91l34.9,20.16a5,5,0,0,0,4.54,0L385.1,321a5,5,0,0,0,2.26-3.93v-1.63a5,5,0,0,0-2.27-3.93l-35-20.12a5,5,0,0,0-4.53,0l-111.06,64a5,5,0,0,0-2.26,3.93V361A5.05,5.05,0,0,0,234.53,364.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.7,291.33c1.72-1,3.52-.42,5.25.58L384.2,311c1.72,1,1.73,2.62,0,3.63l-109.4,63h0a6.24,6.24,0,0,1-6.24,0L235.28,358.6a2.09,2.09,0,0,1,0-3.63h0Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.27,357.4a1.22,1.22,0,0,1,.44-1.67l110.42-63.65c1.17-.67,2.53-.49,4.39.59l33.24,19.12a2,2,0,0,1,.75.68c.39.67-.4,1.22-.75,1.43L274.36,377a5.42,5.42,0,0,1-5.37,0l-33.28-19.12a1.16,1.16,0,0,1-.44-.44m-.76.43a2.1,2.1,0,0,0,.77.77l33.27,19.12a6.24,6.24,0,0,0,6.24,0l109.4-63c1.24-.71,1.59-1.74,1.08-2.63a2.9,2.9,0,0,0-1.07-1L351,291.91c-1.73-1-3.53-1.58-5.25-.58L235.28,355a2.1,2.1,0,0,0-.77,2.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.5,355.42l.77-.45a2.1,2.1,0,0,0,0,3.63l33.27,19.11a6.12,6.12,0,0,0,3.12.84h.08v7.08a4.66,4.66,0,0,1-2.32-.55l-34.9-20.16a5.06,5.06,0,0,1-2.28-3.93v-1.63A5,5,0,0,1,234.5,355.42Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,358.75l11.9-1.32,4.35,2.51-22.94,2.67,4.59-13.27,4.38,2.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.82,344.47l-11.94,1.33-4.34-2.5,22.93-2.67-4.58,13.26-4.38-2.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.55,327.81l45.89-26.5a3.64,3.64,0,0,1,3.29-.05c.89.51.85,1.36-.09,1.9l-45.92,26.48a3.62,3.62,0,0,1-3.28.06C300.57,329.19,300.61,328.35,301.55,327.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.49,332.39l45.9-26.5a3.64,3.64,0,0,1,3.29-.05c.88.51.84,1.36-.09,1.9l-45.92,26.48a3.65,3.65,0,0,1-3.28.06C308.51,333.77,308.56,332.92,309.49,332.39Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.44,337l45.89-26.49a3.63,3.63,0,0,1,3.3-.05c.88.51.84,1.36-.09,1.9l-45.93,26.47a3.6,3.6,0,0,1-3.27.06C316.46,338.35,316.51,337.5,317.44,337Z",
    style: {
      fill: "#e0e0e0"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gear--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162,78.41a1.7,1.7,0,0,1,2.12-.14l2.39,1.8a1.36,1.36,0,0,0,1.92-.29L173,73.42a2.17,2.17,0,0,0,.07-2.29l-1.85-2.86a2.73,2.73,0,0,1-.13-2.41c.59-1.23,1.12-2.49,1.59-3.76a4,4,0,0,1,1.7-1.93l4.51-2.24a3,3,0,0,0,1.45-2l.95-6.66a.9.9,0,0,0-.37-1h0l-.06,0h0l-5.53-3.2h0a1,1,0,0,0-.76-.09l-.52.12a3.31,3.31,0,0,1,.4-1.75l3.82-6a1.92,1.92,0,0,0-.2-2.2l-2.45-2.66a1,1,0,0,0-.34-.25v0L169.73,29h0a1.16,1.16,0,0,0-1.47.31l-3.59,4.32.14-2.4a.88.88,0,0,0-.4-.88h0l-5.59-3.23h0a.94.94,0,0,0-.81,0l-4.87,1.8a2.83,2.83,0,0,0-1.61,1.83l-1.39,6.22a4.23,4.23,0,0,1-1.44,2.15A32.18,32.18,0,0,0,146,41.3a1.7,1.7,0,0,1-.89.41l-3.77-2.18h0a1.37,1.37,0,0,0-1.77.39L135,46.28a2.17,2.17,0,0,0-.06,2.29l1.85,2.86a2.76,2.76,0,0,1,.13,2.41c-.59,1.23-1.13,2.49-1.59,3.76a4,4,0,0,1-1.7,1.93l-4.52,2.25a2.94,2.94,0,0,0-1.44,2l-1,6.66a.92.92,0,0,0,.4,1h0l5.58,3.22h0a1.06,1.06,0,0,0,.76.08l.51-.12a3.22,3.22,0,0,1-.4,1.75l-3.82,6a1.92,1.92,0,0,0,.2,2.2l2.45,2.66a1.42,1.42,0,0,0,.31.25h0l5.56,3.22v0a1.16,1.16,0,0,0,1.53-.26l3.59-4.32-.14,2.41a.88.88,0,0,0,.4.88h0l5.55,3.21h0a1,1,0,0,0,.84,0l4.87-1.8A2.83,2.83,0,0,0,156.49,89l1.39-6.22a4.17,4.17,0,0,1,1.44-2.15A34,34,0,0,0,162,78.41Zm-1-30.55a11.65,11.65,0,0,1,.68,6.55c-1,7.23-6.53,14.8-12.27,16.91a9.13,9.13,0,0,1-2.25.54,11.53,11.53,0,0,1-.68-6.57c1-7.23,6.53-14.8,12.26-16.91A9.25,9.25,0,0,1,160.93,47.86Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,78.41a1.7,1.7,0,0,1,2.12-.14l2.39,1.8a1.36,1.36,0,0,0,1.92-.29L173,73.42a2.17,2.17,0,0,0,.07-2.29l-1.85-2.86a2.73,2.73,0,0,1-.13-2.41c.59-1.23,1.12-2.49,1.59-3.76a4,4,0,0,1,1.7-1.93l4.51-2.24a3,3,0,0,0,1.45-2l.95-6.66a.9.9,0,0,0-.37-1h0l-.06,0h0l-5.53-3.2h0a1,1,0,0,0-.76-.09l-.52.12a3.31,3.31,0,0,1,.4-1.75l3.82-6a1.92,1.92,0,0,0-.2-2.2l-2.45-2.66a1,1,0,0,0-.34-.25v0L169.73,29h0a1.16,1.16,0,0,0-1.47.31l-3.59,4.32.14-2.4a.88.88,0,0,0-.4-.88h0l-5.59-3.23h0a.94.94,0,0,0-.81,0l-4.87,1.8a2.83,2.83,0,0,0-1.61,1.83l-1.39,6.22a4.23,4.23,0,0,1-1.44,2.15A32.18,32.18,0,0,0,146,41.3a1.7,1.7,0,0,1-.89.41l-3.77-2.18h0a1.37,1.37,0,0,0-1.77.39L135,46.28a2.17,2.17,0,0,0-.06,2.29l1.85,2.86a2.76,2.76,0,0,1,.13,2.41c-.59,1.23-1.13,2.49-1.59,3.76a4,4,0,0,1-1.7,1.93l-4.52,2.25a2.94,2.94,0,0,0-1.44,2l-1,6.66a.92.92,0,0,0,.4,1h0l5.58,3.22h0a1.06,1.06,0,0,0,.76.08l.51-.12a3.22,3.22,0,0,1-.4,1.75l-3.82,6a1.92,1.92,0,0,0,.2,2.2l2.45,2.66a1.42,1.42,0,0,0,.31.25h0l5.56,3.22v0a1.16,1.16,0,0,0,1.53-.26l3.59-4.32-.14,2.41a.88.88,0,0,0,.4.88h0l5.55,3.21h0a1,1,0,0,0,.84,0l4.87-1.8A2.83,2.83,0,0,0,156.49,89l1.39-6.22a4.17,4.17,0,0,1,1.44-2.15A34,34,0,0,0,162,78.41Zm-1-30.55a11.65,11.65,0,0,1,.68,6.55c-1,7.23-6.53,14.8-12.27,16.91a9.13,9.13,0,0,1-2.25.54,11.53,11.53,0,0,1-.68-6.57c1-7.23,6.53-14.8,12.26-16.91A9.25,9.25,0,0,1,160.93,47.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.21,38.45a2.36,2.36,0,0,0,2.2-.64l4.41-5.31a1.15,1.15,0,0,1,1.41-.34L169.72,29a1.17,1.17,0,0,0-1.47.31l-3.59,4.32-.19,3.2a1.35,1.35,0,0,0,1.31,1.41A8.37,8.37,0,0,1,167.21,38.45Zm8.15,6.62h0a1,1,0,0,0-.76-.09l-.52.12a2.5,2.5,0,0,0,.1.74,15.3,15.3,0,0,1,.46,2.24,1.21,1.21,0,0,0,1.5,1.07l4-.95a.93.93,0,0,1,.75.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.18,57.63c.89-6.23-1.81-10.17-6.26-9.76a11.51,11.51,0,0,1,.69,6.54c-1,7.23-6.52,14.8-12.27,16.91a8.68,8.68,0,0,1-2.24.53c1.33,2.86,4.19,4,7.81,2.69C160.65,72.43,166.14,64.86,167.18,57.63Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67,55.59a2.11,2.11,0,0,0-.33-.93l-1.84-2.87a2.2,2.2,0,0,1-.26-1.48l-5.57-3.22a2.14,2.14,0,0,0,.26,1.48l1.85,2.87a2.27,2.27,0,0,1,.3.94Zm-10,19h0a.91.91,0,0,1-.4-1l1-6.65a2.73,2.73,0,0,1,.76-1.45l-5.57-3.22a2.84,2.84,0,0,0-.76,1.45l-1,6.67a.9.9,0,0,0,.4,1Zm23.06-34.57,1.37-6.14a2.62,2.62,0,0,1,.78-1.29l-5.56-3.22a2.8,2.8,0,0,0-.79,1.29l-1.37,6.15ZM138.24,90.71a2.21,2.21,0,0,1-.3-.25l-2.45-2.66a1.92,1.92,0,0,1-.2-2.2l3.82-6a2.88,2.88,0,0,0,.36-1.07l-5.57-3.22a2.88,2.88,0,0,1-.36,1.07l-3.82,6a1.93,1.93,0,0,0,.2,2.19l2.45,2.66a1,1,0,0,0,.31.25Zm10.93,1.9a.65.65,0,0,1-.17-.16.69.69,0,0,1-.18-.35,1.5,1.5,0,0,1,0-.38l.32-5.6a.87.87,0,0,0,0-.37,1.16,1.16,0,0,0-.29-.56,1.34,1.34,0,0,0-.39-.31l-.24-.11-.35-.07a7.94,7.94,0,0,1-1.42-.23,2.34,2.34,0,0,0-2.22.64l-.81,1-.15,2.41a.92.92,0,0,0,.41.89h0Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.67,55.59a2.11,2.11,0,0,0-.33-.93l-1.84-2.87a2.2,2.2,0,0,1-.26-1.48l-5.57-3.22a2.14,2.14,0,0,0,.26,1.48l1.85,2.87a2.27,2.27,0,0,1,.3.94Zm-10,19h0a.91.91,0,0,1-.4-1l1-6.65a2.73,2.73,0,0,1,.76-1.45l-5.57-3.22a2.84,2.84,0,0,0-.76,1.45l-1,6.67a.9.9,0,0,0,.4,1Zm23.06-34.57,1.37-6.14a2.62,2.62,0,0,1,.78-1.29l-5.56-3.22a2.8,2.8,0,0,0-.79,1.29l-1.37,6.15ZM138.24,90.71a2.21,2.21,0,0,1-.3-.25l-2.45-2.66a1.92,1.92,0,0,1-.2-2.2l3.82-6a2.88,2.88,0,0,0,.36-1.07l-5.57-3.22a2.88,2.88,0,0,1-.36,1.07l-3.82,6a1.93,1.93,0,0,0,.2,2.19l2.45,2.66a1,1,0,0,0,.31.25Zm10.93,1.9a.65.65,0,0,1-.17-.16.69.69,0,0,1-.18-.35,1.5,1.5,0,0,1,0-.38l.32-5.6a.87.87,0,0,0,0-.37,1.16,1.16,0,0,0-.29-.56,1.34,1.34,0,0,0-.39-.31l-.24-.11-.35-.07a7.94,7.94,0,0,1-1.42-.23,2.34,2.34,0,0,0-2.22.64l-.81,1-.15,2.41a.92.92,0,0,0,.41.89h0Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.49,89l1.39-6.22a4.17,4.17,0,0,1,1.44-2.15A34,34,0,0,0,162,78.41a1.7,1.7,0,0,1,2.12-.14l2.39,1.8a1.36,1.36,0,0,0,1.92-.29L173,73.42a2.17,2.17,0,0,0,.07-2.29l-1.85-2.86a2.73,2.73,0,0,1-.13-2.41c.59-1.23,1.12-2.49,1.59-3.76a4,4,0,0,1,1.7-1.93l4.51-2.24a3,3,0,0,0,1.45-2l.95-6.66a.88.88,0,0,0-1.15-1.06l-4,.95a1.21,1.21,0,0,1-1.5-1.07,16.73,16.73,0,0,0-.46-2.24,3.47,3.47,0,0,1,.3-2.49l3.82-6a1.92,1.92,0,0,0-.2-2.2l-2.45-2.66a1.17,1.17,0,0,0-1.82,0l-4.41,5.3a2.31,2.31,0,0,1-2.2.64,10.94,10.94,0,0,0-1.43-.23,1.36,1.36,0,0,1-1.31-1.41l.33-5.6a.84.84,0,0,0-1.22-.91l-4.87,1.79a2.87,2.87,0,0,0-1.61,1.84l-1.39,6.22a4.23,4.23,0,0,1-1.44,2.15,34.12,34.12,0,0,0-2.67,2.22,1.7,1.7,0,0,1-2.11.13l-2.39-1.79a1.37,1.37,0,0,0-1.93.29l-4.61,6.36a2.17,2.17,0,0,0-.06,2.29l1.85,2.86a2.76,2.76,0,0,1,.13,2.41c-.59,1.23-1.13,2.49-1.59,3.76a4,4,0,0,1-1.7,1.93L134.67,65a3,3,0,0,0-1.44,2l-1,6.66a.89.89,0,0,0,1.16,1.06l4-.95A1.21,1.21,0,0,1,139,74.83a17.06,17.06,0,0,0,.47,2.24,3.47,3.47,0,0,1-.31,2.49l-3.82,6a1.92,1.92,0,0,0,.2,2.2l2.45,2.66a1.18,1.18,0,0,0,1.83,0l4.4-5.31a2.33,2.33,0,0,1,2.21-.64,10.94,10.94,0,0,0,1.43.24,1.35,1.35,0,0,1,1.3,1.41l-.32,5.6a.84.84,0,0,0,1.22.91l4.87-1.79A2.87,2.87,0,0,0,156.49,89Zm-1.58-14.46c-5.73,2.11-9.54-2-8.5-9.25s6.53-14.8,12.26-16.91,9.55,2,8.51,9.25S160.65,72.42,154.91,74.54Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.49,89l1.39-6.22a4.17,4.17,0,0,1,1.44-2.15A34,34,0,0,0,162,78.41a1.7,1.7,0,0,1,2.12-.14l2.39,1.8a1.36,1.36,0,0,0,1.92-.29L173,73.42a2.17,2.17,0,0,0,.07-2.29l-1.85-2.86a2.73,2.73,0,0,1-.13-2.41c.59-1.23,1.12-2.49,1.59-3.76a4,4,0,0,1,1.7-1.93l4.51-2.24a3,3,0,0,0,1.45-2l.95-6.66a.88.88,0,0,0-1.15-1.06l-4,.95a1.21,1.21,0,0,1-1.5-1.07,16.73,16.73,0,0,0-.46-2.24,3.47,3.47,0,0,1,.3-2.49l3.82-6a1.92,1.92,0,0,0-.2-2.2l-2.45-2.66a1.17,1.17,0,0,0-1.82,0l-4.41,5.3a2.31,2.31,0,0,1-2.2.64,10.94,10.94,0,0,0-1.43-.23,1.36,1.36,0,0,1-1.31-1.41l.33-5.6a.84.84,0,0,0-1.22-.91l-4.87,1.79a2.87,2.87,0,0,0-1.61,1.84l-1.39,6.22a4.23,4.23,0,0,1-1.44,2.15,34.12,34.12,0,0,0-2.67,2.22,1.7,1.7,0,0,1-2.11.13l-2.39-1.79a1.37,1.37,0,0,0-1.93.29l-4.61,6.36a2.17,2.17,0,0,0-.06,2.29l1.85,2.86a2.76,2.76,0,0,1,.13,2.41c-.59,1.23-1.13,2.49-1.59,3.76a4,4,0,0,1-1.7,1.93L134.67,65a3,3,0,0,0-1.44,2l-1,6.66a.89.89,0,0,0,1.16,1.06l4-.95A1.21,1.21,0,0,1,139,74.83a17.06,17.06,0,0,0,.47,2.24,3.47,3.47,0,0,1-.31,2.49l-3.82,6a1.92,1.92,0,0,0,.2,2.2l2.45,2.66a1.18,1.18,0,0,0,1.83,0l4.4-5.31a2.33,2.33,0,0,1,2.21-.64,10.94,10.94,0,0,0,1.43.24,1.35,1.35,0,0,1,1.3,1.41l-.32,5.6a.84.84,0,0,0,1.22.91l4.87-1.79A2.87,2.87,0,0,0,156.49,89Zm-1.58-14.46c-5.73,2.11-9.54-2-8.5-9.25s6.53-14.8,12.26-16.91,9.55,2,8.51,9.25S160.65,72.42,154.91,74.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.59,93.1a1.22,1.22,0,0,1-.71-.22,1.32,1.32,0,0,1-.48-1.18l.33-5.6a1,1,0,0,0-1-1,9.13,9.13,0,0,1-1.48-.24,1.94,1.94,0,0,0-1.82.51l-4.4,5.3a1.57,1.57,0,0,1-2.41.07l-2.45-2.67a2.29,2.29,0,0,1-.24-2.67l3.82-6a3.1,3.1,0,0,0,.25-2.18,17.83,17.83,0,0,1-.47-2.29.89.89,0,0,0-.37-.63.77.77,0,0,0-.65-.11l-4,1a1.38,1.38,0,0,1-1.25-.27,1.34,1.34,0,0,1-.38-1.22l1-6.67a3.35,3.35,0,0,1,1.66-2.28L139,62.4a3.56,3.56,0,0,0,1.5-1.72c.47-1.26,1-2.53,1.61-3.79a2.33,2.33,0,0,0-.11-2L140.17,52a2.56,2.56,0,0,1,.08-2.73l4.61-6.36a1.74,1.74,0,0,1,2.47-.37l2.39,1.79a1.31,1.31,0,0,0,1.62-.1A30.65,30.65,0,0,1,154,42a3.9,3.9,0,0,0,1.29-1.93l1.39-6.21a3.24,3.24,0,0,1,1.85-2.12l4.87-1.8a1.23,1.23,0,0,1,1.75,1.3l-.33,5.6a1,1,0,0,0,.95,1,9.08,9.08,0,0,1,1.49.24,1.92,1.92,0,0,0,1.81-.51l4.41-5.31a1.58,1.58,0,0,1,1.19-.59,1.62,1.62,0,0,1,1.22.53l2.45,2.67a2.27,2.27,0,0,1,.24,2.66l-3.82,6a3.11,3.11,0,0,0-.26,2.18A16.42,16.42,0,0,1,175,48a.91.91,0,0,0,.36.63.8.8,0,0,0,.66.11l4-1a1.38,1.38,0,0,1,1.25.27,1.37,1.37,0,0,1,.38,1.22l-1,6.67a3.34,3.34,0,0,1-1.65,2.28l-4.52,2.25a3.66,3.66,0,0,0-1.51,1.71c-.46,1.27-1,2.54-1.6,3.79a2.35,2.35,0,0,0,.11,2l1.84,2.86a2.56,2.56,0,0,1-.07,2.73L168.73,80a1.75,1.75,0,0,1-1.16.7,1.73,1.73,0,0,1-1.32-.33l-2.39-1.79a1.3,1.3,0,0,0-1.61.1,32.5,32.5,0,0,1-2.7,2.25,3.94,3.94,0,0,0-1.3,1.93l-1.38,6.21A3.23,3.23,0,0,1,155,91.2L150.14,93A1.58,1.58,0,0,1,149.59,93.1ZM145.85,84a2.57,2.57,0,0,1,.62.08,10,10,0,0,0,1.37.22,1.74,1.74,0,0,1,1.66,1.83l-.33,5.6a.47.47,0,0,0,.71.52l4.87-1.8a2.46,2.46,0,0,0,1.36-1.56l1.39-6.21a4.72,4.72,0,0,1,1.58-2.39,29.15,29.15,0,0,0,2.64-2.19,2.1,2.1,0,0,1,2.61-.16l2.39,1.8a1,1,0,0,0,.73.19,1,1,0,0,0,.65-.4l4.61-6.36a1.78,1.78,0,0,0,0-1.85l-1.85-2.86a3.15,3.15,0,0,1-.15-2.79c.59-1.23,1.12-2.48,1.57-3.72a4.42,4.42,0,0,1,1.89-2.15l4.52-2.24a2.57,2.57,0,0,0,1.23-1.7l1-6.67a.62.62,0,0,0-.13-.54.59.59,0,0,0-.55-.08l-4,.95a1.6,1.6,0,0,1-1.27-.23,1.63,1.63,0,0,1-.7-1.16,16.79,16.79,0,0,0-.46-2.2,3.84,3.84,0,0,1,.35-2.8l3.82-6a1.53,1.53,0,0,0-.15-1.73l-2.45-2.66a.9.9,0,0,0-.63-.29.86.86,0,0,0-.62.32l-4.4,5.3a2.67,2.67,0,0,1-2.6.77,8.76,8.76,0,0,0-1.36-.22,1.75,1.75,0,0,1-1.67-1.83l.33-5.6a.53.53,0,0,0-.17-.5.56.56,0,0,0-.53,0l-4.87,1.8A2.44,2.44,0,0,0,157.48,34l-1.39,6.22a4.65,4.65,0,0,1-1.59,2.38,32.61,32.61,0,0,0-2.63,2.2,2.1,2.1,0,0,1-2.61.15l-2.39-1.79a1,1,0,0,0-.74-.19.94.94,0,0,0-.64.4l-4.61,6.35a1.8,1.8,0,0,0,0,1.86l1.84,2.86a3.15,3.15,0,0,1,.16,2.79c-.59,1.23-1.12,2.48-1.58,3.72a4.37,4.37,0,0,1-1.89,2.15l-4.52,2.24a2.61,2.61,0,0,0-1.23,1.7l-1,6.67a.57.57,0,0,0,.13.53.56.56,0,0,0,.55.09l4-1a1.57,1.57,0,0,1,1.27.22,1.71,1.71,0,0,1,.7,1.17,16.31,16.31,0,0,0,.45,2.19,3.86,3.86,0,0,1-.35,2.81l-3.82,6a1.55,1.55,0,0,0,.16,1.73l2.45,2.66a.82.82,0,0,0,.63.28.78.78,0,0,0,.61-.31l4.41-5.3A2.58,2.58,0,0,1,145.85,84Zm6.22-8.55a5.68,5.68,0,0,1-3.63-1.22c-2.11-1.71-3-5-2.42-9,1.06-7.34,6.67-15.06,12.52-17.21,2.57-1,4.91-.72,6.61.65,2.11,1.71,3,5,2.41,9C166.51,65,160.9,72.75,155.05,74.9A8.71,8.71,0,0,1,152.07,75.47Zm9.44-27.25a8,8,0,0,0-2.7.52c-5.61,2.07-11,9.52-12,16.6-.54,3.74.24,6.77,2.14,8.3,1.47,1.19,3.55,1.38,5.85.53,5.61-2.06,11-9.51,12-16.59.53-3.75-.25-6.77-2.14-8.31A4.91,4.91,0,0,0,161.51,48.22Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--gear--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.24,130.38l8.85-5.11a2.38,2.38,0,0,0,1-1.66l.89-9.84a3.3,3.3,0,0,1,.92-1.84,53,53,0,0,0,4.92-5.2,1.66,1.66,0,0,1,1.73-.49l5.68,2a1.4,1.4,0,0,0,1.6-.59l6.5-11.27a1.38,1.38,0,0,0-.28-1.68l-4.56-3.93A1.69,1.69,0,0,1,109.1,89a53.48,53.48,0,0,0,2.05-6.85,3.25,3.25,0,0,1,1.13-1.72l8.08-5.69a2.39,2.39,0,0,0,.91-1.74V62.78a.75.75,0,0,0-.32-.66h0l-6.63-3.85h0a.73.73,0,0,0-.69,0l-4.57,2.06a1.93,1.93,0,0,1,.14-1.08l5.24-10.58a1.19,1.19,0,0,0-.46-1.55l-4.34-2.5h0l-8-4.63a1.2,1.2,0,0,0-1.57.37L93.54,50.2a1.92,1.92,0,0,1-.89.67l-.49-5a.74.74,0,0,0-.34-.6h0l-6.64-3.85h0a.71.71,0,0,0-.72.06l-8.85,5.1a2.42,2.42,0,0,0-1.06,1.66l-.88,9.84A3.3,3.3,0,0,1,72.75,60a54.13,54.13,0,0,0-4.92,5.2,1.7,1.7,0,0,1-1.74.5l-5.68-2a1.39,1.39,0,0,0-1.59.59L52.31,75.52a1.4,1.4,0,0,0,.29,1.68l4.56,3.93a1.69,1.69,0,0,1,.44,1.75,51.61,51.61,0,0,0-2.05,6.86,3.26,3.26,0,0,1-1.13,1.71l-8.09,5.69a2.41,2.41,0,0,0-.9,1.74V109.1a.74.74,0,0,0,.3.65h0l6.65,3.87h0a.71.71,0,0,0,.68,0l4.57-2.06a1.93,1.93,0,0,1-.14,1.08L52.25,123.2a1.2,1.2,0,0,0,.47,1.55l6.61,3.83,0,0,5.7,3.29a1.19,1.19,0,0,0,1.56-.37l6.55-9.84A1.94,1.94,0,0,1,74,121l.5,5a.74.74,0,0,0,.34.59h0l6.64,3.86h0A.73.73,0,0,0,82.24,130.38ZM94.9,68.71c1.51,1.61,2.36,4.28,2.36,8,0,9.54-6.69,21.13-14.94,25.89-3,1.75-5.68,2.5-7.84,2.29-1.74-1.82-2.76-4.67-2.76-8.4,0-9.54,6.69-21.13,14.94-25.89C89.71,68.85,92.53,68.27,94.9,68.71Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.24,130.38l8.85-5.11a2.38,2.38,0,0,0,1-1.66l.89-9.84a3.3,3.3,0,0,1,.92-1.84,53,53,0,0,0,4.92-5.2,1.66,1.66,0,0,1,1.73-.49l5.68,2a1.4,1.4,0,0,0,1.6-.59l6.5-11.27a1.38,1.38,0,0,0-.28-1.68l-4.56-3.93A1.69,1.69,0,0,1,109.1,89a53.48,53.48,0,0,0,2.05-6.85,3.25,3.25,0,0,1,1.13-1.72l8.08-5.69a2.39,2.39,0,0,0,.91-1.74V62.78a.75.75,0,0,0-.32-.66h0l-6.63-3.85h0a.73.73,0,0,0-.69,0l-4.57,2.06a1.93,1.93,0,0,1,.14-1.08l5.24-10.58a1.19,1.19,0,0,0-.46-1.55l-4.34-2.5h0l-8-4.63a1.2,1.2,0,0,0-1.57.37L93.54,50.2a1.92,1.92,0,0,1-.89.67l-.49-5a.74.74,0,0,0-.34-.6h0l-6.64-3.85h0a.71.71,0,0,0-.72.06l-8.85,5.1a2.42,2.42,0,0,0-1.06,1.66l-.88,9.84A3.3,3.3,0,0,1,72.75,60a54.13,54.13,0,0,0-4.92,5.2,1.7,1.7,0,0,1-1.74.5l-5.68-2a1.39,1.39,0,0,0-1.59.59L52.31,75.52a1.4,1.4,0,0,0,.29,1.68l4.56,3.93a1.69,1.69,0,0,1,.44,1.75,51.61,51.61,0,0,0-2.05,6.86,3.26,3.26,0,0,1-1.13,1.71l-8.09,5.69a2.41,2.41,0,0,0-.9,1.74V109.1a.74.74,0,0,0,.3.65h0l6.65,3.87h0a.71.71,0,0,0,.68,0l4.57-2.06a1.93,1.93,0,0,1-.14,1.08L52.25,123.2a1.2,1.2,0,0,0,.47,1.55l6.61,3.83,0,0,5.7,3.29a1.19,1.19,0,0,0,1.56-.37l6.55-9.84A1.94,1.94,0,0,1,74,121l.5,5a.74.74,0,0,0,.34.59h0l6.64,3.86h0A.73.73,0,0,0,82.24,130.38ZM94.9,68.71c1.51,1.61,2.36,4.28,2.36,8,0,9.54-6.69,21.13-14.94,25.89-3,1.75-5.68,2.5-7.84,2.29-1.74-1.82-2.76-4.67-2.76-8.4,0-9.54,6.69-21.13,14.94-25.89C89.71,68.85,92.53,68.27,94.9,68.71Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.46,54.9a2.17,2.17,0,0,0,1.72-.85l6.54-9.84a1.17,1.17,0,0,1,1.56-.36l1.35.77-8-4.63a1.21,1.21,0,0,0-1.58.37L93.54,50.2a1.93,1.93,0,0,1-.89.68L93,54.5a.93.93,0,0,0,1.18.83A18.33,18.33,0,0,1,98.46,54.9Zm15.86,3.37h0a.71.71,0,0,0-.68,0l-4.58,2.06a1.94,1.94,0,0,0,.27.82,18.39,18.39,0,0,1,1.75,3.91.94.94,0,0,0,1.32.61l7.87-3.55a.86.86,0,0,1,.62-.05Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.66,105.12c8.26-4.76,15-16.35,15-25.88,0-6-2.67-9.79-6.72-10.54,1.52,1.6,2.37,4.29,2.38,8,0,9.54-6.7,21.13-15,25.89-3,1.75-5.67,2.51-7.82,2.3C77.19,107.74,81.64,108,86.66,105.12Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.22,128.52a1.23,1.23,0,0,1-.34-1.46l5.25-10.58a1.61,1.61,0,0,0,.16-.59L57.65,112a1.83,1.83,0,0,1-.15.59L52.26,123.2a1.19,1.19,0,0,0,.45,1.55Zm22.29,1.91h0a.46.46,0,0,1-.18-.16.52.52,0,0,1-.13-.23,1.3,1.3,0,0,1,0-.21l-.86-8.6a.54.54,0,0,0,0-.22.83.83,0,0,0-.26-.41.92.92,0,0,0-.25-.15l-.15,0a1.24,1.24,0,0,0-.47,0l-.2,0a18.13,18.13,0,0,1-4.06.4A2.3,2.3,0,0,0,74,121l.5,5a.74.74,0,0,0,.33.6h0ZM52.32,113.58a.81.81,0,0,1-.26-.63V102.73a2.26,2.26,0,0,1,.47-1.31l-6.63-3.84a2.39,2.39,0,0,0-.48,1.3V109.1a.71.71,0,0,0,.3.65ZM80,62.84A2.66,2.66,0,0,0,80.3,62l.89-9.85a1.87,1.87,0,0,1,.25-.78L74.82,47.5a2.16,2.16,0,0,0-.27.77l-.88,9.85a3.1,3.1,0,0,1-.26.86ZM58.91,80.61a1.34,1.34,0,0,1,0-1.23l6.5-11.28a1.38,1.38,0,0,1,.65-.54l-6.64-3.85a1.36,1.36,0,0,0-.64.54L52.31,75.52a1.41,1.41,0,0,0,0,1.31Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.22,128.52a1.23,1.23,0,0,1-.34-1.46l5.25-10.58a1.61,1.61,0,0,0,.16-.59L57.65,112a1.83,1.83,0,0,1-.15.59L52.26,123.2a1.19,1.19,0,0,0,.45,1.55Zm22.29,1.91h0a.46.46,0,0,1-.18-.16.52.52,0,0,1-.13-.23,1.3,1.3,0,0,1,0-.21l-.86-8.6a.54.54,0,0,0,0-.22.83.83,0,0,0-.26-.41.92.92,0,0,0-.25-.15l-.15,0a1.24,1.24,0,0,0-.47,0l-.2,0a18.13,18.13,0,0,1-4.06.4A2.3,2.3,0,0,0,74,121l.5,5a.74.74,0,0,0,.33.6h0ZM52.32,113.58a.81.81,0,0,1-.26-.63V102.73a2.26,2.26,0,0,1,.47-1.31l-6.63-3.84a2.39,2.39,0,0,0-.48,1.3V109.1a.71.71,0,0,0,.3.65ZM80,62.84A2.66,2.66,0,0,0,80.3,62l.89-9.85a1.87,1.87,0,0,1,.25-.78L74.82,47.5a2.16,2.16,0,0,0-.27.77l-.88,9.85a3.1,3.1,0,0,1-.26.86ZM58.91,80.61a1.34,1.34,0,0,1,0-1.23l6.5-11.28a1.38,1.38,0,0,1,.65-.54l-6.64-3.85a1.36,1.36,0,0,0-.64.54L52.31,75.52a1.41,1.41,0,0,0,0,1.31Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.14,123.61l.89-9.84a3.3,3.3,0,0,1,.92-1.84,53,53,0,0,0,4.92-5.2,1.66,1.66,0,0,1,1.73-.49l5.68,2a1.4,1.4,0,0,0,1.6-.59l6.5-11.27a1.38,1.38,0,0,0-.28-1.68l-4.56-3.93A1.69,1.69,0,0,1,109.1,89a53.48,53.48,0,0,0,2.05-6.85,3.25,3.25,0,0,1,1.13-1.72l8.08-5.69a2.39,2.39,0,0,0,.91-1.74V62.78a.66.66,0,0,0-1-.65l-7.88,3.55a.93.93,0,0,1-1.31-.61,18.08,18.08,0,0,0-1.75-3.9,2.18,2.18,0,0,1-.12-1.91l5.24-10.58a1.19,1.19,0,0,0-.46-1.55l-5.7-3.28a1.17,1.17,0,0,0-1.56.36l-6.55,9.84a2.14,2.14,0,0,1-1.71.85,18.28,18.28,0,0,0-4.26.43A.93.93,0,0,1,93,54.5l-.86-8.59a.66.66,0,0,0-1.07-.55l-8.85,5.11a2.34,2.34,0,0,0-1,1.65L80.3,62a3.31,3.31,0,0,1-.92,1.83A54.25,54.25,0,0,0,74.46,69a1.68,1.68,0,0,1-1.73.49l-5.68-2a1.38,1.38,0,0,0-1.6.59L59,79.37a1.38,1.38,0,0,0,.28,1.68L63.79,85a1.7,1.7,0,0,1,.44,1.75,55.27,55.27,0,0,0-2.05,6.86,3.32,3.32,0,0,1-1.13,1.72L53,101a2.39,2.39,0,0,0-.91,1.74V113a.66.66,0,0,0,1,.65L61,110.05a.94.94,0,0,1,1.31.61,17.87,17.87,0,0,0,1.75,3.9,2.18,2.18,0,0,1,.12,1.91l-5.25,10.59a1.19,1.19,0,0,0,.47,1.54l5.7,3.29a1.18,1.18,0,0,0,1.56-.37l6.55-9.84a2.2,2.2,0,0,1,1.71-.85,17.26,17.26,0,0,0,4.26-.43.94.94,0,0,1,1.18.83l.86,8.6a.66.66,0,0,0,1.07.55l8.85-5.11A2.38,2.38,0,0,0,92.14,123.61Zm-5.48-18.48c-8.25,4.76-14.94.9-14.94-8.63s6.69-21.13,14.94-25.89,15-.91,15,8.63S94.92,100.36,86.66,105.13Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.14,123.61l.89-9.84a3.3,3.3,0,0,1,.92-1.84,53,53,0,0,0,4.92-5.2,1.66,1.66,0,0,1,1.73-.49l5.68,2a1.4,1.4,0,0,0,1.6-.59l6.5-11.27a1.38,1.38,0,0,0-.28-1.68l-4.56-3.93A1.69,1.69,0,0,1,109.1,89a53.48,53.48,0,0,0,2.05-6.85,3.25,3.25,0,0,1,1.13-1.72l8.08-5.69a2.39,2.39,0,0,0,.91-1.74V62.78a.66.66,0,0,0-1-.65l-7.88,3.55a.93.93,0,0,1-1.31-.61,18.08,18.08,0,0,0-1.75-3.9,2.18,2.18,0,0,1-.12-1.91l5.24-10.58a1.19,1.19,0,0,0-.46-1.55l-5.7-3.28a1.17,1.17,0,0,0-1.56.36l-6.55,9.84a2.14,2.14,0,0,1-1.71.85,18.28,18.28,0,0,0-4.26.43A.93.93,0,0,1,93,54.5l-.86-8.59a.66.66,0,0,0-1.07-.55l-8.85,5.11a2.34,2.34,0,0,0-1,1.65L80.3,62a3.31,3.31,0,0,1-.92,1.83A54.25,54.25,0,0,0,74.46,69a1.68,1.68,0,0,1-1.73.49l-5.68-2a1.38,1.38,0,0,0-1.6.59L59,79.37a1.38,1.38,0,0,0,.28,1.68L63.79,85a1.7,1.7,0,0,1,.44,1.75,55.27,55.27,0,0,0-2.05,6.86,3.32,3.32,0,0,1-1.13,1.72L53,101a2.39,2.39,0,0,0-.91,1.74V113a.66.66,0,0,0,1,.65L61,110.05a.94.94,0,0,1,1.31.61,17.87,17.87,0,0,0,1.75,3.9,2.18,2.18,0,0,1,.12,1.91l-5.25,10.59a1.19,1.19,0,0,0,.47,1.54l5.7,3.29a1.18,1.18,0,0,0,1.56-.37l6.55-9.84a2.2,2.2,0,0,1,1.71-.85,17.26,17.26,0,0,0,4.26-.43.94.94,0,0,1,1.18.83l.86,8.6a.66.66,0,0,0,1.07.55l8.85-5.11A2.38,2.38,0,0,0,92.14,123.61Zm-5.48-18.48c-8.25,4.76-14.94.9-14.94-8.63s6.69-21.13,14.94-25.89,15-.91,15,8.63S94.92,100.36,86.66,105.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.62,132.36a1.49,1.49,0,0,1-.73-.2l-5.7-3.29a1.51,1.51,0,0,1-.59-2l5.25-10.59a1.85,1.85,0,0,0-.1-1.6,17.84,17.84,0,0,1-1.79-4,.66.66,0,0,0-.36-.42.59.59,0,0,0-.52,0l-7.88,3.55a1,1,0,0,1-1.45-.94V102.74a2.67,2.67,0,0,1,1-2l8.08-5.69a3,3,0,0,0,1-1.53,52.78,52.78,0,0,1,2.06-6.9,1.39,1.39,0,0,0-.36-1.4L59,81.29a1.69,1.69,0,0,1-.35-2.07L65.18,68a1.7,1.7,0,0,1,2-.73l5.68,2a1.36,1.36,0,0,0,1.39-.4,53.85,53.85,0,0,1,5-5.23A3,3,0,0,0,80,61.94l.88-9.85a2.71,2.71,0,0,1,1.21-1.89l8.85-5.11a1.06,1.06,0,0,1,1-.08,1,1,0,0,1,.53.86l.86,8.6a.62.62,0,0,0,.25.46.69.69,0,0,0,.55.1,17.77,17.77,0,0,1,4.34-.44,1.9,1.9,0,0,0,1.44-.71L106.45,44a1.53,1.53,0,0,1,2-.47l5.7,3.29a1.52,1.52,0,0,1,.59,2L109.48,59.4a1.87,1.87,0,0,0,.1,1.61,17.76,17.76,0,0,1,1.79,4,.71.71,0,0,0,.36.43.6.6,0,0,0,.52,0l7.88-3.55a1.06,1.06,0,0,1,1,0,1,1,0,0,1,.44.91V73a2.68,2.68,0,0,1-1,2l-8.08,5.69a3,3,0,0,0-1,1.52,52.7,52.7,0,0,1-2,6.9,1.39,1.39,0,0,0,.35,1.41l4.55,3.92a1.71,1.71,0,0,1,.36,2.08l-6.51,11.26a1.69,1.69,0,0,1-2,.74l-5.68-2a1.4,1.4,0,0,0-1.39.4,53.85,53.85,0,0,1-5,5.23,3.09,3.09,0,0,0-.82,1.64l-.88,9.84h0a2.72,2.72,0,0,1-1.21,1.9l-8.85,5.11a1,1,0,0,1-1.54-.79l-.86-8.6a.66.66,0,0,0-.25-.46.69.69,0,0,0-.55-.09,18.28,18.28,0,0,1-4.34.44,1.89,1.89,0,0,0-1.44.71l-6.54,9.84A1.54,1.54,0,0,1,65.62,132.36Zm-4.26-22.71a1.24,1.24,0,0,1,.5.1,1.32,1.32,0,0,1,.7.81,17,17,0,0,0,1.72,3.84,2.47,2.47,0,0,1,.14,2.21L59.17,127.2a.87.87,0,0,0,.34,1.13l5.69,3.29a.88.88,0,0,0,1.15-.27l6.54-9.84a2.46,2.46,0,0,1,2-1,17.42,17.42,0,0,0,4.18-.43,1.35,1.35,0,0,1,1.06.2,1.24,1.24,0,0,1,.5.91l.87,8.6a.41.41,0,0,0,.19.36.41.41,0,0,0,.4-.06L90.93,125a2,2,0,0,0,.9-1.4h0l.89-9.85a3.62,3.62,0,0,1,1-2,53.74,53.74,0,0,0,4.88-5.17,2,2,0,0,1,2.09-.59l5.68,2a1.07,1.07,0,0,0,1.22-.45l6.5-11.27a1.07,1.07,0,0,0-.22-1.28L109.34,91a2,2,0,0,1-.54-2.1,53,53,0,0,0,2-6.81,3.57,3.57,0,0,1,1.26-1.91l8.08-5.69A2,2,0,0,0,121,73V62.78a.42.42,0,0,0-.15-.38.43.43,0,0,0-.41,0L112.51,66a1.26,1.26,0,0,1-1,0,1.29,1.29,0,0,1-.7-.81,17.44,17.44,0,0,0-1.72-3.84,2.47,2.47,0,0,1-.14-2.21l5.25-10.58a.87.87,0,0,0-.34-1.13l-5.69-3.29a.88.88,0,0,0-1.15.27l-6.54,9.84a2.46,2.46,0,0,1-2,1,16.9,16.9,0,0,0-4.18.42,1.3,1.3,0,0,1-1.06-.2,1.22,1.22,0,0,1-.5-.91l-.87-8.59a.35.35,0,0,0-.59-.31L82.4,50.74a2.07,2.07,0,0,0-.9,1.41L80.61,62a3.59,3.59,0,0,1-1,2,52.72,52.72,0,0,0-4.88,5.18,2,2,0,0,1-2.09.59l-5.68-2a1.09,1.09,0,0,0-1.22.45l-6.5,11.27a1.07,1.07,0,0,0,.22,1.28L64,84.74a2,2,0,0,1,.54,2.1,52.67,52.67,0,0,0-2,6.82,3.55,3.55,0,0,1-1.26,1.9l-8.08,5.69a2.08,2.08,0,0,0-.77,1.48V113a.35.35,0,0,0,.56.37l7.88-3.55A1.32,1.32,0,0,1,61.36,109.65ZM80,107.49a8,8,0,0,1-4-1c-2.93-1.69-4.54-5.22-4.54-10,0-9.62,6.78-21.36,15.11-26.17,4.09-2.36,8-2.73,10.88-1s4.54,5.22,4.54,9.95c0,9.61-6.78,21.35-15.11,26.16A13.86,13.86,0,0,1,80,107.49ZM93.34,68.87a13.33,13.33,0,0,0-6.52,2C78.67,75.59,72,87.08,72,96.5c0,4.49,1.5,7.83,4.22,9.4s6.37,1.2,10.26-1.05c8.15-4.7,14.79-16.2,14.79-25.61,0-4.5-1.5-7.84-4.22-9.41A7.39,7.39,0,0,0,93.34,68.87Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--device--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Monitor--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.86,375l-32.48-18.76c-6.66-3.85-17.89-4.73-25.08-2L153,361.69a111.11,111.11,0,0,0-24,13.63l-19.62,15.45c-2.82,2.22-4.21,4.92-4.21,7.56,0,.74,0,3.72,0,4.48,0,3,1.81,5.88,5.33,7.91L143,429.47c6.67,3.85,17.48,3.85,24.14,0l62.68-36.18c3.35-1.94,5-4.47,5-7V382C234.86,379.43,233.2,376.91,229.86,375Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.23,402.81c0,3,1.81,5.88,5.33,7.91L143,429.47a24.6,24.6,0,0,0,12.07,2.89v-4.63l-49.89-28.81C105.22,400.07,105.22,402.19,105.23,402.81Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.23,402.81c0,3,1.81,5.88,5.33,7.91L143,429.47a24.6,24.6,0,0,0,12.07,2.89v-4.63l-49.89-28.81C105.22,400.07,105.22,402.19,105.23,402.81Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.3,354.27,153,361.69a111.11,111.11,0,0,0-24,13.63l-19.62,15.45c-6,4.76-5.55,11.74,1.12,15.59L143,425.12c6.67,3.84,17.48,3.84,24.14,0l62.68-36.19c6.67-3.85,6.67-10.09,0-13.94l-32.48-18.76C190.72,352.38,179.49,351.5,172.3,354.27Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.38,356.23c-6.66-3.85-17.89-4.73-25.08-2L153,361.69a111.11,111.11,0,0,0-24,13.63l-19.62,15.45c-2.82,2.22-4.21,4.92-4.21,7.56,0,.74,0,3.72,0,4.48,0,3,1.81,5.88,5.33,7.91l18.09,10.45v-4.34l86.85-50.14Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,376c0-9.58,3-39.74,9.29-46.79l-20.11-2.23c-9.89,10.46-21.73,35.43-28.9,49.82,0,0,5.9,2.4,13.19,5.41s17.41,3,22.62,0a7,7,0,0,0,3.9-6.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167,376c0-9.58,3-39.74,9.29-46.79l-20.11-2.23c-9.89,10.46-21.73,35.43-28.9,49.82,0,0,5.9,2.4,13.19,5.41s17.41,3,22.62,0a7,7,0,0,0,3.9-6.21Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.19,329.85c3.91,1.61,9.33,1.61,12.13,0s2.79-4.75,0-7l-5.06-4.09a57.93,57.93,0,0,0-14.13,8.19S159.29,328.23,163.19,329.85Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.21,405.14a11.47,11.47,0,0,0,10.36-.2L307,264.38a11.84,11.84,0,0,0,5.35-9.26V30.17a11.47,11.47,0,0,0-5-9.06A11.44,11.44,0,0,0,297,21.3L53.55,161.86a11.84,11.84,0,0,0-5.35,9.26v225A11.46,11.46,0,0,0,53.21,405.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.58,404.94,307,264.37a11.82,11.82,0,0,0,5.35-9.26V30.17c0-3.41-2.4-4.79-5.35-3.09L63.58,167.65a11.82,11.82,0,0,0-5.35,9.26V401.85C58.23,405.26,60.62,406.64,63.58,404.94Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.23,383.66v18.19c0,3.41,2.39,4.79,5.35,3.09L307,264.37a11.82,11.82,0,0,0,5.35-9.26V236.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.29,366.74V179.29a7.25,7.25,0,0,1,3.28-5.69L302,38.81c1.81-1,3.28-.19,3.28,1.9V228.17a7.28,7.28,0,0,1-3.28,5.7L68.58,368.64C66.77,369.69,65.29,368.84,65.29,366.74Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.78,165.84l10,5.78a11.45,11.45,0,0,0-1.58,5.28v225c0,3.11,2.1,4.85,5.34,3.09a11.36,11.36,0,0,1-10.36.2,10.32,10.32,0,0,1-5-8.43V171.12A11,11,0,0,1,49.78,165.84Z",
    style: {
      fill: "#263238"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.28,50.19a1.51,1.51,0,0,0-.06-.37.08.08,0,0,0,0-.08,1.2,1.2,0,0,0-.09-.35,1.87,1.87,0,0,0-.23-.52.85.85,0,0,0-.14-.21.49.49,0,0,0-.11-.14,1.34,1.34,0,0,0-.27-.26l0,0A3,3,0,0,0,317,48a2.91,2.91,0,0,0-2.69.35L83.6,181.23c-2.21,1.27-4,4.38-4,8.84V378.86A2.73,2.73,0,0,0,81,381.27l.17.11.21.12a1.7,1.7,0,0,0,.34.12,2.22,2.22,0,0,0,.51.06,2.63,2.63,0,0,0,1.33-.38l.1-.06h0l3.82-2.2L314.31,248.38a8.85,8.85,0,0,0,4-6.93V50.69A3.84,3.84,0,0,0,318.28,50.19Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.08,49a1,1,0,0,1,.45.1l.07,0,0,0,.06.05.1.13h0v0l.08.13a.48.48,0,0,1,.08.16l0,0,.1.32v0l0,0,0,.06a.45.45,0,0,1,0,.11c0,.13,0,.27,0,.41V241.45a7.71,7.71,0,0,1-3.43,5.94L87,378l-3.71,2.15h0l-.1.06-.1.06a1.63,1.63,0,0,1-.7.23h-.06l-.26,0-.08,0h0l-.11-.06-.09-.06-.06,0,0,0,0,0a1.58,1.58,0,0,1-.85-1.4v-2h0V190.07c0-4.33,1.77-6.89,3.43-7.85L314.87,49.37a2.65,2.65,0,0,1,1.21-.39m0-1.14a3.58,3.58,0,0,0-1.77.54L83.6,181.23c-2.21,1.27-4,4.38-4,8.84V378h0v.87A2.73,2.73,0,0,0,81,381.27l.17.11.21.12a1.7,1.7,0,0,0,.34.12,2.22,2.22,0,0,0,.51.06h.06a2.63,2.63,0,0,0,1.27-.38l.1-.06h0l3.82-2.2L314.31,248.38a8.85,8.85,0,0,0,4-6.93V50.69a3.84,3.84,0,0,0,0-.5,1.51,1.51,0,0,0-.06-.37.08.08,0,0,0,0-.08,1.2,1.2,0,0,0-.09-.35,1.87,1.87,0,0,0-.23-.52.85.85,0,0,0-.14-.21.49.49,0,0,0-.11-.14,1.34,1.34,0,0,0-.27-.26l0,0A3,3,0,0,0,317,48a2.17,2.17,0,0,0-.92-.19Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317,48a2.91,2.91,0,0,0-2.69.35L83.6,181.23a8.84,8.84,0,0,0-4,6.93v7.75l-5.11-3v-7.66a8.85,8.85,0,0,1,4-6.92L309.2,45.49a2.8,2.8,0,0,1,2.9-.24C312.82,45.69,316.14,47.59,317,48Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,50.66c0-2.53-1.8-3.55-4-2.28L83.6,181.24a8.82,8.82,0,0,0-4,6.92v7.76L318.3,58.46Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M314.3,48.38,83.6,181.23a8.41,8.41,0,0,0-2.82,3l-5.08-2.94a8,8,0,0,1,2.79-2.92L309.2,45.49a2.8,2.8,0,0,1,2.9-.24c.72.44,4,2.32,4.88,2.78A2.9,2.9,0,0,0,314.3,48.38Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M74.49,192.94v-7.68a8.24,8.24,0,0,1,1.21-4l5.1,2.93a8,8,0,0,0-1.2,4v7.76Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.94,60a4.05,4.05,0,0,0-1.7,3.24c0,1.25.76,1.82,1.7,1.28a4.05,4.05,0,0,0,1.7-3.24C302.64,60.07,301.88,59.5,300.94,60Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.05,56.5a4.09,4.09,0,0,0-1.7,3.25c0,1.25.76,1.82,1.7,1.28a4.05,4.05,0,0,0,1.7-3.24C308.75,56.54,308,56,307.05,56.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.16,53a4.05,4.05,0,0,0-1.7,3.24c0,1.25.76,1.83,1.7,1.29a4.07,4.07,0,0,0,1.7-3.25C314.86,53,314.1,52.43,313.16,53Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,381.28l-.2-.11-4.22-2.44a4.26,4.26,0,0,1-2.09-3.1,5.83,5.83,0,0,1,0-.59V192.92l5.11,3V378.86a2.62,2.62,0,0,0,1.24,2.27,1,1,0,0,0,.13.09s0,0,0,0Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81,381.28l-.2-.11-4.22-2.44a4.26,4.26,0,0,1-2.09-3.1,5.83,5.83,0,0,1,0-.59V192.92l5.11,3V378.86a2.62,2.62,0,0,0,1.24,2.27,1,1,0,0,0,.13.09s0,0,0,0Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Color--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--color--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M234.4,285l104.4-60.28c.67-.38,1.22-.07,1.22.71V257.9A2.72,2.72,0,0,1,338.8,260L234.4,320.29c-.67.39-1.22.08-1.22-.7V287.11A2.72,2.72,0,0,1,234.4,285Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.28,291.69a3.36,3.36,0,0,1,.16-.33h0A3.41,3.41,0,0,0,242.28,291.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59,231.32a.71.71,0,0,0-.69-.56,1.23,1.23,0,0,0-.62.19L243.41,290.34a2.81,2.81,0,0,0-1,1l-5-2.89a3,3,0,0,1,.93-1l102.87-59.38a3.06,3.06,0,0,1,2.75,0l2.29,1.28A2.94,2.94,0,0,1,347.59,231.32Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.59,231.32a.71.71,0,0,0-.69-.56,1.23,1.23,0,0,0-.62.19L243.41,290.34a2.81,2.81,0,0,0-1,1l-5-2.89a3,3,0,0,1,.93-1l102.87-59.38a3.06,3.06,0,0,1,2.75,0l2.29,1.28A2.94,2.94,0,0,1,347.59,231.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.41,325.57a3.14,3.14,0,0,1-2.74,0l-2.3-1.36a3,3,0,0,1-1.38-2.36v-32a2.87,2.87,0,0,1,.44-1.4l5,2.89a2.74,2.74,0,0,0-.4,1.35v32.07C242.05,325.58,242.61,326,243.41,325.57Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.41,325.57a3.14,3.14,0,0,1-2.74,0l-2.3-1.36a3,3,0,0,1-1.38-2.36v-32a2.87,2.87,0,0,1,.44-1.4l5,2.89a2.74,2.74,0,0,0-.4,1.35v32.07C242.05,325.58,242.61,326,243.41,325.57Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M346.89,230.76a1.22,1.22,0,0,0-.61.19L243.41,290.34a3,3,0,0,0-1.36,2.37v32.07c0,.62.3,1,.75,1a1.2,1.2,0,0,0,.61-.19l102.87-59.39a3,3,0,0,0,1.37-2.37V231.74c0-.62-.31-1-.76-1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,232v31.79a2,2,0,0,1-.83,1.44L243.12,324.5V292.71a2,2,0,0,1,.83-1.44L346.57,232m.32-1.26a1.22,1.22,0,0,0-.61.19L243.41,290.34a3,3,0,0,0-1.36,2.37v32.07c0,.62.3,1,.75,1a1.2,1.2,0,0,0,.61-.19l102.87-59.39a3,3,0,0,0,1.37-2.37V231.74c0-.62-.31-1-.76-1Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.89,231.37c.14,0,.15.31.15.37v32.07a2.42,2.42,0,0,1-1.06,1.84L243.11,325a.63.63,0,0,1-.31.11c-.14,0-.14-.31-.14-.37V292.71a2.39,2.39,0,0,1,1.06-1.84l102.87-59.39a.61.61,0,0,1,.3-.11m0-.61a1.22,1.22,0,0,0-.61.19L243.41,290.34a3,3,0,0,0-1.36,2.37v32.07c0,.62.3,1,.75,1a1.2,1.2,0,0,0,.61-.19l102.87-59.39a3,3,0,0,0,1.37-2.37V231.74c0-.62-.31-1-.76-1Z",
    style: {
      fill: "#3B3355"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M263.14,296.53c0,4.41-2.68,9.52-6,11.43s-6-.12-6-4.52,2.68-9.53,6-11.43S263.14,292.12,263.14,296.53Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.14,296.53c0,4.41-2.68,9.52-6,11.43s-6-.12-6-4.52,2.68-9.53,6-11.43S263.14,292.12,263.14,296.53Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,285.65c0,4.4-2.68,9.52-6,11.43s-6-.12-6-4.52,2.68-9.53,6-11.44S282,281.24,282,285.65Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,285.65c0,4.4-2.68,9.52-6,11.43s-6-.12-6-4.52,2.68-9.53,6-11.44S282,281.24,282,285.65Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.85,
    cy: 278.22,
    rx: 9.19,
    ry: 5.2,
    transform: "translate(-76.61 440.59) rotate(-66.95)",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.85,
    cy: 278.22,
    rx: 9.19,
    ry: 5.2,
    transform: "translate(-76.61 440.59) rotate(-66.95)",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.68,263.88c0,4.41-2.68,9.53-6,11.44s-6-.12-6-4.53,2.68-9.52,6-11.43S319.68,259.48,319.68,263.88Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53,253c0,4.41-2.68,9.53-6,11.44s-6-.12-6-4.53,2.68-9.52,6-11.43S338.53,248.6,338.53,253Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.53,253c0,4.41-2.68,9.53-6,11.44s-6-.12-6-4.53,2.68-9.52,6-11.43S338.53,248.6,338.53,253Z",
    style: {
      opacity: 0.2
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Fonts--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--fonts--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M234.4,229.51l104.4-60.28c.67-.39,1.22-.07,1.22.71v32.48a2.68,2.68,0,0,1-1.22,2.11L234.4,264.81c-.67.39-1.22.08-1.22-.7V231.62A2.72,2.72,0,0,1,234.4,229.51Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.28,236.13a3.36,3.36,0,0,1,.16-.33h0A3.41,3.41,0,0,0,242.28,236.13Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.59,175.76a.71.71,0,0,0-.69-.56,1.23,1.23,0,0,0-.62.19L243.41,234.78a2.81,2.81,0,0,0-1,1l-5-2.89a3,3,0,0,1,.93-1l102.87-59.38a3.06,3.06,0,0,1,2.75,0l2.29,1.28A2.94,2.94,0,0,1,347.59,175.76Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.59,175.76a.71.71,0,0,0-.69-.56,1.23,1.23,0,0,0-.62.19L243.41,234.78a2.81,2.81,0,0,0-1,1l-5-2.89a3,3,0,0,1,.93-1l102.87-59.38a3.06,3.06,0,0,1,2.75,0l2.29,1.28A2.94,2.94,0,0,1,347.59,175.76Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M243.41,270a3.14,3.14,0,0,1-2.74,0l-2.3-1.36a3,3,0,0,1-1.38-2.35v-32a2.87,2.87,0,0,1,.44-1.4l5,2.89a2.77,2.77,0,0,0-.4,1.35v32.07C242.05,270,242.61,270.48,243.41,270Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M243.41,270a3.14,3.14,0,0,1-2.74,0l-2.3-1.36a3,3,0,0,1-1.38-2.35v-32a2.87,2.87,0,0,1,.44-1.4l5,2.89a2.77,2.77,0,0,0-.4,1.35v32.07C242.05,270,242.61,270.48,243.41,270Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M346.89,175.2a1.22,1.22,0,0,0-.61.19L243.41,234.78a3,3,0,0,0-1.36,2.37v32.07c0,.62.3,1,.75,1a1.2,1.2,0,0,0,.61-.19l102.87-59.39a3,3,0,0,0,1.37-2.37V176.18c0-.62-.31-1-.76-1Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.57,176.46v31.79a2,2,0,0,1-.83,1.44L243.12,268.94V237.15a2,2,0,0,1,.83-1.44l102.62-59.25m.32-1.26a1.22,1.22,0,0,0-.61.19L243.41,234.78a3,3,0,0,0-1.36,2.37v32.07c0,.62.3,1,.75,1a1.2,1.2,0,0,0,.61-.19l102.87-59.39a3,3,0,0,0,1.37-2.37V176.18c0-.62-.31-1-.76-1Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.89,175.81c.14,0,.15.31.15.37v32.07a2.42,2.42,0,0,1-1.06,1.84L243.11,269.48a.63.63,0,0,1-.31.11c-.14,0-.14-.31-.14-.37V237.15a2.41,2.41,0,0,1,1.06-1.84l102.87-59.39a.61.61,0,0,1,.3-.11m0-.61a1.22,1.22,0,0,0-.61.19L243.41,234.78a3,3,0,0,0-1.36,2.37v32.07c0,.62.3,1,.75,1a1.2,1.2,0,0,0,.61-.19l102.87-59.39a3,3,0,0,0,1.37-2.37V176.18c0-.62-.31-1-.76-1Z",
    style: {
      fill: "#3B3355"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.19,236.8l1.45-1.17L290.32,217l1.45-.84,3.68,14.52,1.2-.48v1.25l-5.09,3v-1.25l1.55-1.2-.85-3.53-3.84,2.22-.85,4.43,1.53-.54v1.28l-3.91,2.26Zm3.54-7.75,3.23-1.87-1.6-6.59Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.32,226.47c-.87,1.88-1.43,2.92-2.56,3.57-1.32.76-2.35.16-2.35-2.07,0-1.74.62-3.4,3.16-6.11.46-.51,1.08-1.14,1.7-1.74v-.76c0-2.53-.41-3-1.56-2.34a5.21,5.21,0,0,0-.72.53l-.21,1.62a3.1,3.1,0,0,1-1.11,2.54c-.55.31-.9.08-1-.65a7.5,7.5,0,0,1,3.72-5.74c2.05-1.18,3-.31,3,3.22v5.92c0,.87.19,1.11.51.93a1.84,1.84,0,0,0,.62-1l.4.31a4.11,4.11,0,0,1-1.82,2.76C303.13,228,302.53,227.63,302.32,226.47Zm-1.59,1c.48-.28.78-.72,1.54-2v-4.31c-.5.53-1,1-1.26,1.37a5.58,5.58,0,0,0-1.53,3.63C299.48,227.62,300,227.9,300.73,227.5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,236.71c.18-.1.32-.1.41,0a1.2,1.2,0,0,1,.23.53l4.12,14a.44.44,0,0,1,0,.17,1.31,1.31,0,0,1-.13.57.86.86,0,0,1-.32.39l-1.21.7c-.23.13-.39.15-.47.06a.79.79,0,0,1-.19-.33l-.72-2.45-5.32,3.07-.72,3.29a2.45,2.45,0,0,1-.19.53,1.05,1.05,0,0,1-.47.49l-1.21.7a.24.24,0,0,1-.32,0,.55.55,0,0,1-.13-.41.65.65,0,0,1,0-.2L253.47,239a3.29,3.29,0,0,1,.23-.79,1.06,1.06,0,0,1,.4-.46Zm.93,10.84L255,241.24l-1.85,8.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.11,241.14a7.93,7.93,0,0,1,.31-1.35,8.1,8.1,0,0,1,.69-1.56,8.39,8.39,0,0,1,1.09-1.53,6.37,6.37,0,0,1,1.51-1.22,3.65,3.65,0,0,1,1.55-.54,1.66,1.66,0,0,1,1.18.34,2.51,2.51,0,0,1,.77,1.25,7.51,7.51,0,0,1,.27,2.19v7.61a1.33,1.33,0,0,1-.14.57.81.81,0,0,1-.32.39l-1.28.74a.24.24,0,0,1-.32,0,.55.55,0,0,1-.13-.41v-.86a7.64,7.64,0,0,1-1,1.87,5.36,5.36,0,0,1-1.69,1.51,2.94,2.94,0,0,1-1.29.45,1.36,1.36,0,0,1-1-.29,2,2,0,0,1-.6-.94,4.68,4.68,0,0,1-.21-1.5,6.62,6.62,0,0,1,.83-3.27,9.18,9.18,0,0,1,2.2-2.64l2.74-2.31c0-.71-.15-1.12-.45-1.24a1.31,1.31,0,0,0-1.13.21,2.17,2.17,0,0,0-.66.56,5.66,5.66,0,0,0-.45.76,2.25,2.25,0,0,1-.28.44.92.92,0,0,1-.28.24l-1.56.9a.24.24,0,0,1-.29,0A.41.41,0,0,1,262.11,241.14Zm2.81,5.68a4.08,4.08,0,0,0,1-.84,5.37,5.37,0,0,0,.74-1.09,5.13,5.13,0,0,0,.46-1.19,4.85,4.85,0,0,0,.15-1.15v-.26L265,244.23a4.37,4.37,0,0,0-1,1.1,2.24,2.24,0,0,0-.3,1.12c0,.37.12.56.36.6A1.46,1.46,0,0,0,264.92,246.82Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,209a5.19,5.19,0,0,1,.3,1.44,1.85,1.85,0,0,1-.75,1.45l-.1.06c-.55.31-.7-.35-.83-.95l-.49-2.13-.39-1.54c-.88.53-1.75,1.06-2.63,1.64l-1.65,1.17-.35.25c-.31,1.34-.64,2.71-.92,4.08-.21.85-.3,1.94-.93,2.3s-.84-.11-.84-.67a3.08,3.08,0,0,1,.15-.94l1-4.1a1.24,1.24,0,0,1-.17-.77,1.87,1.87,0,0,1,.75-1.64c.35-1.43.69-2.86,1.05-4.3.57-2.26,1.21-4.66,1.66-6.88l.15-.62a2.14,2.14,0,0,1,.72-1.45l.25-.17a.36.36,0,0,1,.44,0c.12.05.23.2.28.61.31,1.41.63,2.85,1,4.24.66,2.64,1.38,5.27,2.09,7.88Zm-2.74-3.73-.18-.65-1-3.76-.37-1.29-.12.51-1.37,5.48c-.17.7-.34,1.38-.5,2.07C326,206.91,327.13,206.09,328.29,205.3Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.42,204.72a2.46,2.46,0,0,1-.85,1.89c-.35.2-.65-.21-.82-.64a8.3,8.3,0,0,1-2.71,2.87c-2,1.15-3.92,0-3.92-3.77a13.09,13.09,0,0,1,.8-4.33,9.52,9.52,0,0,1,3.7-5,3.34,3.34,0,0,1,2-.47,2.57,2.57,0,0,1,.43-1.12,1.69,1.69,0,0,1,.53-.5c.53-.31.61.52.61.83s0,.54-.06.74c-.11,1.15-.16,4.1-.16,4.85s.06,2.89.06,3.56S340.42,204.26,340.42,204.72Zm-2-1.53c0-.14.08-.29.13-.46v-4.4a1.91,1.91,0,0,0-.21-.14,1.51,1.51,0,0,0-1.86.06c-1.49.86-3,3.39-3,6.15,0,1.57.73,3.22,2.49,2.2A5.69,5.69,0,0,0,338.42,203.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.3,245.49a.47.47,0,0,1-.47-.47V220.44a.47.47,0,1,1,.94,0V245A.47.47,0,0,1,277.3,245.49Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.77,224.43a.47.47,0,0,1-.47-.47V199.38a.47.47,0,1,1,.94,0V224A.47.47,0,0,1,313.77,224.43Z",
    style: {
      fill: "#455a64"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Controls--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--controls--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.67,106.77,338,60.41c.68-.39,1.22-.07,1.22.7v85.67A2.69,2.69,0,0,1,338,148.9l-80.31,46.36c-.68.39-1.22.07-1.22-.71V108.88A2.69,2.69,0,0,1,257.67,106.77Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M346.93,65.4a1.57,1.57,0,0,0-1.43.2l-79.36,45.69A4.79,4.79,0,0,0,264,115v83.7a1.54,1.54,0,0,0,.59,1.37c-.37-.24-3.62-2.08-4-2.31a1.54,1.54,0,0,1-.62-1.39V112.7A4.78,4.78,0,0,1,262.1,109l79.35-45.7a1.51,1.51,0,0,1,1.54-.14C343.34,63.33,346.17,64.93,346.93,65.4Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.93,65.4c-.76-.47-3.59-2.07-3.94-2.28a1.51,1.51,0,0,0-1.54.14L262.1,109a4.54,4.54,0,0,0-1.52,1.61l4,2.33a4.54,4.54,0,0,1,1.52-1.61L345.5,65.6A1.57,1.57,0,0,1,346.93,65.4Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M266.14,111.29,345.5,65.6c1.19-.69,2.15-.13,2.15,1.24v83.7a4.76,4.76,0,0,1-2.15,3.73L266.14,200c-1.19.68-2.15.13-2.15-1.25V115A4.77,4.77,0,0,1,266.14,111.29Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.46,65.3v1.08s.1.16.1.46v83.7a3.7,3.7,0,0,1-1.61,2.8L265.6,199a1.08,1.08,0,0,1-.44.16.8.8,0,0,1-.1-.47V115a3.68,3.68,0,0,1,1.62-2.8L346,66.53a1,1,0,0,1,.43-.15V65.3m0,0a1.94,1.94,0,0,0-1,.3l-79.36,45.69A4.77,4.77,0,0,0,264,115v83.69c0,1,.48,1.54,1.19,1.54a1.92,1.92,0,0,0,1-.29l79.36-45.7a4.76,4.76,0,0,0,2.15-3.73V66.84c0-1-.48-1.54-1.19-1.54Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.62,112.9l-4-2.33a4.34,4.34,0,0,0-.64,2.13v83.69a1.54,1.54,0,0,0,.62,1.39c.4.23,3.65,2.07,4,2.31a1.54,1.54,0,0,1-.59-1.37V115A4.43,4.43,0,0,1,264.62,112.9Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.62,112.9l-4-2.33a4.34,4.34,0,0,0-.64,2.13v83.69a1.54,1.54,0,0,0,.62,1.39c.4.23,3.65,2.07,4,2.31a1.54,1.54,0,0,1-.59-1.37V115A4.43,4.43,0,0,1,264.62,112.9Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.46,66.3c.19,0,.2.49.2.54v83.7a3.79,3.79,0,0,1-1.66,2.87l-79.36,45.7a1,1,0,0,1-.46.16c-.19,0-.2-.49-.2-.55V115a3.79,3.79,0,0,1,1.66-2.87L346,66.46a1.07,1.07,0,0,1,.47-.16m0-1a1.94,1.94,0,0,0-1,.3l-79.36,45.69A4.77,4.77,0,0,0,264,115v83.69c0,1,.48,1.54,1.19,1.54a1.92,1.92,0,0,0,1-.29l79.36-45.7a4.76,4.76,0,0,0,2.15-3.73V66.84c0-1-.48-1.54-1.19-1.54Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--controls--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.07,165.86l.12-63.81c0-1.19-.78-1.71-1.75-1.15a4,4,0,0,0-1.76,3.17l-.12,63.82c0,1.19.78,1.71,1.75,1.15A4,4,0,0,0,306.07,165.86Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.05,148.25l0,17.61a4,4,0,0,1-1.76,3.18c-1,.56-1.75,0-1.75-1.15l0-17.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.18,156.42a4.39,4.39,0,0,1-1.64.58v-6.72l3.51-2v6.59A7.86,7.86,0,0,1,304.18,156.42Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,146.69c0-2.84-2-4-4.46-2.57a9.85,9.85,0,0,0-4.45,7.72c0,2.84,2,4,4.45,2.57A9.86,9.86,0,0,0,308.75,146.69Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.75,146.69c0-2.84-2-4-4.46-2.57a9.85,9.85,0,0,0-4.45,7.72c0,2.84,2,4,4.45,2.57A9.86,9.86,0,0,0,308.75,146.69Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.69,173.58l.13-63.81c0-1.19-.78-1.71-1.75-1.15a4,4,0,0,0-1.76,3.18l-.13,63.81c0,1.19.79,1.71,1.76,1.15A4,4,0,0,0,292.69,173.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.76,126.63l-.07,47a4,4,0,0,1-1.75,3.18c-1,.56-1.76,0-1.76-1.15l.07-47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.89,134.58a4.26,4.26,0,0,1-1.65.58v-6.5l3.51-2V133A8,8,0,0,1,290.89,134.58Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.46,124.85c0-2.84-2-4-4.46-2.57a9.83,9.83,0,0,0-4.45,7.71c0,2.84,2,4,4.45,2.58A9.86,9.86,0,0,0,295.46,124.85Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.46,124.85c0-2.84-2-4-4.46-2.57a9.83,9.83,0,0,0-4.45,7.71c0,2.84,2,4,4.45,2.58A9.86,9.86,0,0,0,295.46,124.85Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.32,181.3l.13-63.81c0-1.19-.79-1.71-1.76-1.15a4,4,0,0,0-1.75,3.18l-.13,63.81c0,1.19.79,1.71,1.76,1.15A4,4,0,0,0,279.32,181.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.3,163.69l0,17.61a4,4,0,0,1-1.75,3.18c-1,.56-1.76,0-1.76-1.15l0-17.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.44,171.86a4.39,4.39,0,0,1-1.64.58v-6.72l3.5-2v6.59A7.86,7.86,0,0,1,277.44,171.86Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,162.13c0-2.84-2-4-4.45-2.57a9.85,9.85,0,0,0-4.45,7.72c0,2.84,2,4,4.45,2.57A9.85,9.85,0,0,0,282,162.13Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,162.13c0-2.84-2-4-4.45-2.57a9.85,9.85,0,0,0-4.45,7.72c0,2.84,2,4,4.45,2.57A9.85,9.85,0,0,0,282,162.13Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--controls--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.82,150.42l.12-63.82c0-1.19-.78-1.7-1.75-1.14a4,4,0,0,0-1.76,3.17l-.12,63.81c0,1.2.78,1.71,1.75,1.15A4,4,0,0,0,332.82,150.42Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.8,132.81l0,17.61a4,4,0,0,1-1.76,3.17c-1,.56-1.75,0-1.75-1.15l0-17.61Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.93,141a4.42,4.42,0,0,1-1.64.59v-6.73l3.51-2v6.59A7.59,7.59,0,0,1,330.93,141Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.5,131.25c0-2.84-2-4-4.46-2.57a9.83,9.83,0,0,0-4.45,7.71c0,2.84,2,4,4.45,2.57A9.84,9.84,0,0,0,335.5,131.25Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.5,131.25c0-2.84-2-4-4.46-2.57a9.83,9.83,0,0,0-4.45,7.71c0,2.84,2,4,4.45,2.57A9.84,9.84,0,0,0,335.5,131.25Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.44,158.14l.13-63.82c0-1.19-.78-1.7-1.75-1.14a4,4,0,0,0-1.76,3.17l-.13,63.81c0,1.2.79,1.71,1.76,1.15A4,4,0,0,0,319.44,158.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.51,111.19l-.07,46.95a4,4,0,0,1-1.75,3.17c-1,.56-1.76.05-1.76-1.15l.07-46.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.64,119.13a4.29,4.29,0,0,1-1.65.59v-6.51l3.51-2v6.39A7.67,7.67,0,0,1,317.64,119.13Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.21,109.41c0-2.84-2-4-4.46-2.58a9.87,9.87,0,0,0-4.45,7.72c0,2.84,2,4,4.45,2.57A9.84,9.84,0,0,0,322.21,109.41Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.21,109.41c0-2.84-2-4-4.46-2.58a9.87,9.87,0,0,0-4.45,7.72c0,2.84,2,4,4.45,2.57A9.84,9.84,0,0,0,322.21,109.41Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Image--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--image--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.26,170.4l94.56-54.59c.67-.39,1.22-.08,1.22.7v85.67a2.72,2.72,0,0,1-1.22,2.12l-94.56,54.59c-.67.39-1.22.07-1.22-.7V172.52A2.72,2.72,0,0,1,147.26,170.4Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M250.29,120.85a1.57,1.57,0,0,0-1.43.2l-92.7,53.53a4.75,4.75,0,0,0-2.15,3.73V262a1.56,1.56,0,0,0,.59,1.38c-.37-.24-3.63-2.08-4-2.32a1.53,1.53,0,0,1-.62-1.38V176a4.75,4.75,0,0,1,2.16-3.73l92.69-53.54a1.54,1.54,0,0,1,1.54-.14C246.7,118.78,249.52,120.39,250.29,120.85Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.29,120.85c-.77-.46-3.59-2.07-3.94-2.28a1.54,1.54,0,0,0-1.54.14l-92.69,53.54a4.37,4.37,0,0,0-1.53,1.6l4,2.34a4.38,4.38,0,0,1,1.52-1.61l92.7-53.53A1.57,1.57,0,0,1,250.29,120.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M156.16,174.58l92.69-53.53c1.19-.69,2.16-.13,2.16,1.25V206a4.74,4.74,0,0,1-2.16,3.73l-92.69,53.53c-1.19.69-2.16.13-2.16-1.24v-83.7A4.78,4.78,0,0,1,156.16,174.58Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.16,174.58l92.69-53.53c1.19-.69,2.16-.13,2.16,1.25V206a4.74,4.74,0,0,1-2.16,3.73l-92.69,53.53c-1.19.69-2.16.13-2.16-1.24v-83.7A4.78,4.78,0,0,1,156.16,174.58Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M154.64,176.19l-4-2.34A4.43,4.43,0,0,0,150,176v83.7a1.53,1.53,0,0,0,.62,1.38c.39.24,3.65,2.08,4,2.32A1.56,1.56,0,0,1,154,262V178.31A4.36,4.36,0,0,1,154.64,176.19Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.64,176.19l-4-2.34A4.43,4.43,0,0,0,150,176v83.7a1.53,1.53,0,0,0,.62,1.38c.39.24,3.65,2.08,4,2.32A1.56,1.56,0,0,1,154,262V178.31A4.36,4.36,0,0,1,154.64,176.19Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.68,202.34l7.33,10.3L188.9,182.5,154,241.62V262c0,1.37,1,1.93,2.16,1.24l92.69-53.53A4.74,4.74,0,0,0,251,206v-11.2L226.32,177Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.67,152.79c4.33-2.5,7.83-.47,7.83,4.52a17.27,17.27,0,0,1-7.83,13.55c-4.32,2.5-7.82.47-7.82-4.52A17.28,17.28,0,0,1,218.67,152.79Z",
    style: {
      fill: "#fafafa",
      opacity: 0.9500000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.82,121.75c.19,0,.19.49.19.55V206a3.78,3.78,0,0,1-1.65,2.87l-92.7,53.53a1,1,0,0,1-.46.16c-.19,0-.2-.49-.2-.54v-83.7a3.76,3.76,0,0,1,1.66-2.87l92.69-53.53a1,1,0,0,1,.47-.16m0-1a2,2,0,0,0-1,.29l-92.69,53.53a4.78,4.78,0,0,0-2.16,3.73V262c0,1,.49,1.54,1.2,1.54a2,2,0,0,0,1-.3l92.69-53.53A4.74,4.74,0,0,0,251,206V122.3c0-1-.49-1.54-1.19-1.54Z",
    style: {
      fill: "#3B3355"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Code--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M95.73,309.7l122.79-70.89c2.39-1.38,4.33-.26,4.33,2.5v80.91a9.58,9.58,0,0,1-4.33,7.5L95.73,400.61c-2.39,1.38-4.33.26-4.33-2.5V317.2A9.58,9.58,0,0,1,95.73,309.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M226.83,248.26a1.51,1.51,0,0,0-.07-.38s0,0,0-.08a1.36,1.36,0,0,0-.09-.36,2.45,2.45,0,0,0-.24-.52.7.7,0,0,0-.14-.21c0-.05-.06-.11-.12-.15a1.6,1.6,0,0,0-.26-.26l0,0a2.43,2.43,0,0,0-.35-.2,3,3,0,0,0-2.73.35L103.87,314.87c-2.24,1.29-4.07,4.45-4.07,9v80.67c0-1.93,0-1.92,0-1.91v.89a2.74,2.74,0,0,0,1.46,2.44l.17.12.22.12a1.7,1.7,0,0,0,.34.12,2.37,2.37,0,0,0,.52.06,2.62,2.62,0,0,0,1.35-.38l.1-.07h0l3.87-2.23,114.94-66.22a9,9,0,0,0,4.07-7V248.76C226.86,248.59,226.84,248.42,226.83,248.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.52,246.07a3,3,0,0,0-2.73.35L103.87,314.87a9,9,0,0,0-4.07,7v7.87l-5-2.94v-7.78a9,9,0,0,1,4-7l118.94-68.46a2.84,2.84,0,0,1,2.95-.24C221.45,243.78,224.66,245.62,225.52,246.07Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.85,248.74c0-2.57-1.83-3.6-4.06-2.32L103.87,314.88a8.94,8.94,0,0,0-4.06,7v7.88l127-73.12Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M222.79,246.42,103.87,314.87a8.41,8.41,0,0,0-2.86,3L96,315a8.08,8.08,0,0,1,2.82-3l118.93-68.45a2.84,2.84,0,0,1,2.95-.24c.73.45,3.93,2.27,4.79,2.72A3,3,0,0,0,222.79,246.42Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M94.78,326.85v-7.79A8.29,8.29,0,0,1,96,315l5,2.87a8.25,8.25,0,0,0-1.21,4v7.87Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.85,257.07a4.07,4.07,0,0,0-1.54,3.27c0,1.31.69,2,1.54,1.48a4.06,4.06,0,0,0,1.54-3.26C212.39,257.24,211.7,256.58,210.85,257.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,253.86a4.06,4.06,0,0,0-1.54,3.26c0,1.32.69,2,1.54,1.49a4.08,4.08,0,0,0,1.54-3.27C217.94,254,217.25,253.37,216.4,253.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222,250.65a4.06,4.06,0,0,0-1.54,3.26c0,1.31.69,2,1.54,1.49a4.06,4.06,0,0,0,1.55-3.27C223.5,250.82,222.81,250.16,222,250.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.26,406l-.21-.12-4.11-2.38a4.29,4.29,0,0,1-2.12-3.15,3.81,3.81,0,0,1,0-.59V326.84l5,2.94v73.7a2.67,2.67,0,0,0,1.27,2.31,1,1,0,0,0,.13.09s0,0,0,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.49,367.56l5.26-3c.52-.3,1,0,1,.56V367a2.13,2.13,0,0,1-1,1.65l-5.25,3c-.53.31-1,.06-1-.55v-1.93A2.11,2.11,0,0,1,107.49,367.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.49,375.24l5.26-3c.52-.31,1-.06,1,.55v1.93a2.11,2.11,0,0,1-1,1.65l-5.25,3c-.53.3-1,.05-1-.55v-1.94A2.14,2.14,0,0,1,107.49,375.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.49,382.93l5.26-3c.52-.3,1-.05,1,.55v1.94a2.14,2.14,0,0,1-1,1.65l-5.25,3c-.53.31-1,.06-1-.55v-1.93A2.11,2.11,0,0,1,107.49,382.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.49,390.61l5.26-3c.52-.31,1-.06,1,.55v1.93a2.11,2.11,0,0,1-1,1.65l-5.25,3c-.53.3-1,.05-1-.56v-1.93A2.14,2.14,0,0,1,107.49,390.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.49,333.29l5.26-3c.52-.31,1-.06,1,.55v1.93a2.11,2.11,0,0,1-1,1.65l-5.25,3c-.53.31-1,.06-1-.55v-1.93A2.11,2.11,0,0,1,107.49,333.29Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.49,341l5.26-3c.52-.3,1-.06,1,.55v1.93a2.14,2.14,0,0,1-1,1.66l-5.25,3c-.53.3-1,.06-1-.55v-1.93A2.14,2.14,0,0,1,107.49,341Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.49,348.66l5.26-3c.52-.31,1-.06,1,.55v1.93a2.11,2.11,0,0,1-1,1.65l-5.25,3c-.53.31-1,.06-1-.55v-1.93A2.11,2.11,0,0,1,107.49,348.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.49,356.34l5.26-3c.52-.3,1-.06,1,.55v1.93a2.14,2.14,0,0,1-1,1.66l-5.25,3c-.53.3-1,.06-1-.55V358A2.14,2.14,0,0,1,107.49,356.34Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,326.91l29.38-17c.53-.31,1-.09,1,.49a2.09,2.09,0,0,1-1,1.6L121.1,329c-.54.31-1,.09-1-.49A2.07,2.07,0,0,1,121.1,326.91Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.06,352.19l45.07-26.09c.54-.31,1-.09,1,.49a2.05,2.05,0,0,1-1,1.6l-45.07,26.09c-.53.31-1,.09-1-.48A2.07,2.07,0,0,1,121.06,352.19Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.22,307.75l12.5-7.21c.53-.31,1-.09,1,.49a2.08,2.08,0,0,1-1,1.6l-12.5,7.21c-.53.31-1,.09-1-.49A2.07,2.07,0,0,1,154.22,307.75Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,332.92l10.56-6.15c.53-.3,1-.09,1,.49a2.05,2.05,0,0,1-1,1.6L121.1,335c-.54.31-1,.09-1-.49A2.07,2.07,0,0,1,121.1,332.92Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,332.92l10.56-6.15c.53-.3,1-.09,1,.49a2.05,2.05,0,0,1-1,1.6L121.1,335c-.54.31-1,.09-1-.49A2.07,2.07,0,0,1,121.1,332.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,338.89l11.59-6.67c.53-.31,1-.09,1,.49a2.07,2.07,0,0,1-1,1.6L121.1,341c-.54.3-1,.08-1-.49A2.07,2.07,0,0,1,121.1,338.89Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,338.89l11.59-6.67c.53-.31,1-.09,1,.49a2.07,2.07,0,0,1-1,1.6L121.1,341c-.54.3-1,.08-1-.49A2.07,2.07,0,0,1,121.1,338.89Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.4,324.61l8.78-5.1c.53-.31,1-.09,1,.48a2.08,2.08,0,0,1-1,1.61l-8.78,5.1c-.53.31-1,.09-1-.48A2.1,2.1,0,0,1,135.4,324.61Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.4,324.61l8.78-5.1c.53-.31,1-.09,1,.48a2.08,2.08,0,0,1-1,1.61l-8.78,5.1c-.53.31-1,.09-1-.48A2.1,2.1,0,0,1,135.4,324.61Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.15,361.43l35.57-20.75c.54-.31,1-.09,1,.49a2,2,0,0,1-1,1.6l-35.57,20.75c-.53.31-1,.09-1-.49A2.09,2.09,0,0,1,131.15,361.43Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.15,355.46l35.57-20.78c.53-.31,1-.09,1,.49a2.08,2.08,0,0,1-1,1.6l-35.57,20.78c-.53.31-1,.09-1-.49A2.09,2.09,0,0,1,131.15,355.46Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.79,330.45l10.36-6.07c.53-.31,1-.09,1,.49a2.07,2.07,0,0,1-1,1.6l-10.36,6.07c-.53.31-1,.09-1-.49A2.09,2.09,0,0,1,135.79,330.45Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.79,330.45l10.36-6.07c.53-.31,1-.09,1,.49a2.07,2.07,0,0,1-1,1.6l-10.36,6.07c-.53.31-1,.09-1-.49A2.09,2.09,0,0,1,135.79,330.45Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,322.22,166.15,313c.54-.31,1-.09,1,.49a2.05,2.05,0,0,1-1,1.6l-16.26,9.18c-.53.31-1,.09-1-.49A2.07,2.07,0,0,1,149.89,322.22Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,322.22,166.15,313c.54-.31,1-.09,1,.49a2.05,2.05,0,0,1-1,1.6l-16.26,9.18c-.53.31-1,.09-1-.49A2.07,2.07,0,0,1,149.89,322.22Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.06,345.2l25.09-14.41c.53-.31,1-.09,1,.49a2.05,2.05,0,0,1-1,1.6l-25.09,14.41c-.53.31-1,.09-1-.48A2.07,2.07,0,0,1,121.06,345.2Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.06,345.2l25.09-14.41c.53-.31,1-.09,1,.49a2.05,2.05,0,0,1-1,1.6l-25.09,14.41c-.53.31-1,.09-1-.48A2.07,2.07,0,0,1,121.06,345.2Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,328.63l16.26-9.18c.54-.3,1-.09,1,.49a2.07,2.07,0,0,1-1,1.61l-16.26,9.17c-.53.31-1,.09-1-.49A2.08,2.08,0,0,1,149.89,328.63Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.89,328.63l16.26-9.18c.54-.3,1-.09,1,.49a2.07,2.07,0,0,1-1,1.61l-16.26,9.17c-.53.31-1,.09-1-.49A2.08,2.08,0,0,1,149.89,328.63Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.15,367.48l35.57-20.6c.54-.31,1-.09,1,.48a2.07,2.07,0,0,1-1,1.61l-35.57,20.6c-.53.31-1,.09-1-.49A2.08,2.08,0,0,1,131.15,367.48Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.15,373.47l35.57-20.61c.54-.31,1-.09,1,.49a2,2,0,0,1-1,1.6l-35.57,20.61c-.53.3-1,.09-1-.49A2.06,2.06,0,0,1,131.15,373.47Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.15,379.45l35.57-20.6c.54-.31,1-.09,1,.49a2.07,2.07,0,0,1-1,1.6l-35.57,20.6c-.53.31-1,.09-1-.49A2.09,2.09,0,0,1,131.15,379.45Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,360.3l4.47-2.57c.53-.3,1-.08,1,.49a2.08,2.08,0,0,1-1,1.61l-4.47,2.56c-.54.31-1,.09-1-.48A2.07,2.07,0,0,1,121.3,360.3Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,360.3l4.47-2.57c.53-.3,1-.08,1,.49a2.08,2.08,0,0,1-1,1.61l-4.47,2.56c-.54.31-1,.09-1-.48A2.07,2.07,0,0,1,121.3,360.3Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,373.17l4.47-2.56c.53-.31,1-.09,1,.48a2.08,2.08,0,0,1-1,1.61l-4.47,2.57c-.54.3-1,.08-1-.49A2.07,2.07,0,0,1,121.3,373.17Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,373.17l4.47-2.56c.53-.31,1-.09,1,.48a2.08,2.08,0,0,1-1,1.61l-4.47,2.57c-.54.3-1,.08-1-.49A2.07,2.07,0,0,1,121.3,373.17Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,379.16l4.47-2.57c.53-.31,1-.09,1,.49a2.05,2.05,0,0,1-1,1.6l-4.47,2.57c-.54.31-1,.09-1-.49A2.07,2.07,0,0,1,121.3,379.16Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,379.16l4.47-2.57c.53-.31,1-.09,1,.49a2.05,2.05,0,0,1-1,1.6l-4.47,2.57c-.54.31-1,.09-1-.49A2.07,2.07,0,0,1,121.3,379.16Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,385.15l4.47-2.57c.53-.31,1-.09,1,.49a2.08,2.08,0,0,1-1,1.6l-4.47,2.57c-.54.31-1,.09-1-.49A2,2,0,0,1,121.3,385.15Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.3,385.15l4.47-2.57c.53-.31,1-.09,1,.49a2.08,2.08,0,0,1-1,1.6l-4.47,2.57c-.54.31-1,.09-1-.49A2,2,0,0,1,121.3,385.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.42,270.6l-37.69,21.76a5.6,5.6,0,0,0-2.53,4.38V353.5c0,1.61,1.14,2.27,2.53,1.46l37.69-21.76a5.62,5.62,0,0,0,2.53-4.38V272.06C219,270.45,217.81,269.79,216.42,270.6Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,313.73l-3.47,2a2.74,2.74,0,0,0-1.28,2.12c0,.77.57,1.06,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C214.2,313.61,213.63,313.32,212.92,313.73Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,313.73l-3.47,2a2.74,2.74,0,0,0-1.28,2.12c0,.77.57,1.06,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C214.2,313.61,213.63,313.32,212.92,313.73Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,278.1l-3.47,2a2.72,2.72,0,0,0-1.28,2.12c0,.77.57,1.06,1.28.65l3.47-2a2.72,2.72,0,0,0,1.28-2.12C214.2,278,213.63,277.69,212.92,278.1Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,278.1l-3.47,2a2.72,2.72,0,0,0-1.28,2.12c0,.77.57,1.06,1.28.65l3.47-2a2.72,2.72,0,0,0,1.28-2.12C214.2,278,213.63,277.69,212.92,278.1Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,288l-3.47,2a2.77,2.77,0,0,0-1.28,2.13c0,.76.58,1,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C209.32,287.91,208.75,287.62,208,288Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,288l-3.47,2a2.77,2.77,0,0,0-1.28,2.13c0,.76.58,1,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C209.32,287.91,208.75,287.62,208,288Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,295.13l-3.47,2a2.77,2.77,0,0,0-1.28,2.13c0,.76.58,1.05,1.28.64l3.47-2a2.74,2.74,0,0,0,1.28-2.13C209.32,295,208.75,294.73,208,295.13Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,295.13l-3.47,2a2.77,2.77,0,0,0-1.28,2.13c0,.76.58,1.05,1.28.64l3.47-2a2.74,2.74,0,0,0,1.28-2.13C209.32,295,208.75,294.73,208,295.13Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,299.47l-3.47,2a2.74,2.74,0,0,0-1.28,2.13c0,.76.57,1.05,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C214.2,299.36,213.63,299.07,212.92,299.47Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,299.47l-3.47,2a2.74,2.74,0,0,0-1.28,2.13c0,.76.57,1.05,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C214.2,299.36,213.63,299.07,212.92,299.47Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,309.41l-3.47,2a2.77,2.77,0,0,0-1.28,2.13c0,.77.58,1.06,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C209.32,309.29,208.75,309,208,309.41Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,309.41l-3.47,2a2.77,2.77,0,0,0-1.28,2.13c0,.77.58,1.06,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C209.32,309.29,208.75,309,208,309.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,283.59l-21.19,12.23A2.77,2.77,0,0,0,181,298c0,.76.58,1.05,1.28.64l21.19-12.23a2.74,2.74,0,0,0,1.28-2.12C204.7,283.47,204.13,283.18,203.42,283.59Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,283.59l-21.19,12.23A2.77,2.77,0,0,0,181,298c0,.76.58,1.05,1.28.64l21.19-12.23a2.74,2.74,0,0,0,1.28-2.12C204.7,283.47,204.13,283.18,203.42,283.59Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,319.22l-21.19,12.23a2.77,2.77,0,0,0-1.28,2.13c0,.76.58,1.05,1.28.65L203.42,322a2.72,2.72,0,0,0,1.28-2.12C204.7,319.1,204.13,318.81,203.42,319.22Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,319.22l-21.19,12.23a2.77,2.77,0,0,0-1.28,2.13c0,.76.58,1.05,1.28.65L203.42,322a2.72,2.72,0,0,0,1.28-2.12C204.7,319.1,204.13,318.81,203.42,319.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,293.51,182.23,303a2.75,2.75,0,0,0-1.28,2.12c0,.77.58,1.06,1.28.65l16.31-9.43a2.74,2.74,0,0,0,1.28-2.13C199.82,293.39,199.25,293.1,198.54,293.51Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,293.51,182.23,303a2.75,2.75,0,0,0-1.28,2.12c0,.77.58,1.06,1.28.65l16.31-9.43a2.74,2.74,0,0,0,1.28-2.13C199.82,293.39,199.25,293.1,198.54,293.51Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,300.64l-16.31,9.43A2.77,2.77,0,0,0,181,312.2c0,.77.58,1.06,1.28.65l16.31-9.44a2.74,2.74,0,0,0,1.28-2.12C199.82,300.52,199.25,300.23,198.54,300.64Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,300.64l-16.31,9.43A2.77,2.77,0,0,0,181,312.2c0,.77.58,1.06,1.28.65l16.31-9.44a2.74,2.74,0,0,0,1.28-2.12C199.82,300.52,199.25,300.23,198.54,300.64Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,305,182.23,317.2a2.77,2.77,0,0,0-1.28,2.13c0,.76.58,1.05,1.28.64l21.19-12.23a2.74,2.74,0,0,0,1.28-2.13C204.7,304.85,204.13,304.56,203.42,305Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,305,182.23,317.2a2.77,2.77,0,0,0-1.28,2.13c0,.76.58,1.05,1.28.64l21.19-12.23a2.74,2.74,0,0,0,1.28-2.13C204.7,304.85,204.13,304.56,203.42,305Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,314.89l-16.31,9.44a2.75,2.75,0,0,0-1.28,2.12c0,.77.58,1.06,1.28.65l16.31-9.43a2.74,2.74,0,0,0,1.28-2.13C199.82,314.78,199.25,314.49,198.54,314.89Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,314.89l-16.31,9.44a2.75,2.75,0,0,0-1.28,2.12c0,.77.58,1.06,1.28.65l16.31-9.43a2.74,2.74,0,0,0,1.28-2.13C199.82,314.78,199.25,314.49,198.54,314.89Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,328.06l-3.47,2a2.74,2.74,0,0,0-1.28,2.13c0,.76.57,1.05,1.28.64l3.47-2a2.74,2.74,0,0,0,1.28-2.13C214.2,327.94,213.63,327.65,212.92,328.06Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.92,328.06l-3.47,2a2.74,2.74,0,0,0-1.28,2.13c0,.76.57,1.05,1.28.64l3.47-2a2.74,2.74,0,0,0,1.28-2.13C214.2,327.94,213.63,327.65,212.92,328.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,323.74l-3.47,2a2.77,2.77,0,0,0-1.28,2.13c0,.77.58,1.06,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C209.32,323.62,208.75,323.33,208,323.74Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208,323.74l-3.47,2a2.77,2.77,0,0,0-1.28,2.13c0,.77.58,1.06,1.28.65l3.47-2a2.74,2.74,0,0,0,1.28-2.13C209.32,323.62,208.75,323.33,208,323.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,333.55l-21.19,12.23a2.77,2.77,0,0,0-1.28,2.13c0,.77.58,1.06,1.28.65l21.19-12.24a2.72,2.72,0,0,0,1.28-2.12C204.7,333.43,204.13,333.14,203.42,333.55Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.42,333.55l-21.19,12.23a2.77,2.77,0,0,0-1.28,2.13c0,.77.58,1.06,1.28.65l21.19-12.24a2.72,2.72,0,0,0,1.28-2.12C204.7,333.43,204.13,333.14,203.42,333.55Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,329.22l-16.31,9.44a2.75,2.75,0,0,0-1.28,2.12c0,.77.58,1.06,1.28.65L198.54,332a2.74,2.74,0,0,0,1.28-2.13C199.82,329.11,199.25,328.82,198.54,329.22Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,329.22l-16.31,9.44a2.75,2.75,0,0,0-1.28,2.12c0,.77.58,1.06,1.28.65L198.54,332a2.74,2.74,0,0,0,1.28-2.13C199.82,329.11,199.25,328.82,198.54,329.22Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Icon--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--code-icon--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.62,252.64l41.52-24c.67-.39,1.22-.07,1.22.7v36.14a2.7,2.7,0,0,1-1.22,2.11l-41.52,24c-.67.39-1.22.08-1.22-.7V254.76A2.72,2.72,0,0,1,92.62,252.64Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.4,234,96,255.05a3,3,0,0,0-1.35,2.33v33.78A2.92,2.92,0,0,0,96,293.47l2.56,1.46a3,3,0,0,0,2.7,0l36.43-21a3,3,0,0,0,1.35-2.33V237.79a2.93,2.93,0,0,0-1.36-2.31L135.1,234A3,3,0,0,0,132.4,234Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,294.91a3.08,3.08,0,0,1-2.7,0L96,293.47a2.93,2.93,0,0,1-1.36-2.31V257.38a2.81,2.81,0,0,1,.43-1.37l5.24,3a2.69,2.69,0,0,0-.4,1.32v33.77C99.89,294.92,100.44,295.37,101.24,294.91Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139,237.55c-.11-.68-.66-.92-1.33-.53l-36.43,21a2.81,2.81,0,0,0-.95,1L95,256a2.86,2.86,0,0,1,.93-1l36.44-21a3,3,0,0,1,2.69,0l2.56,1.46A3,3,0,0,1,139,237.55Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,237l-36.43,21a3,3,0,0,0-1.35,2.33v33.78c0,.85.6,1.2,1.35.77l36.43-21a3,3,0,0,0,1.35-2.33V237.79C139,236.94,138.41,236.59,137.67,237Z",
    style: {
      fill: "#3B3355"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik----inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.5,274.86a2.09,2.09,0,0,1,.15-.83,5.13,5.13,0,0,1,.42-.78l8-12.85.12-.15.09-.06a.23.23,0,0,1,.3,0,.5.5,0,0,1,.12.39v5a2.15,2.15,0,0,1-.23,1,7.77,7.77,0,0,1-.4.68l-3.48,5.34L112,274a1.75,1.75,0,0,1,.4.19c.15.1.23.35.23.76v5a1.24,1.24,0,0,1-.12.53.76.76,0,0,1-.3.35.19.19,0,0,1-.09,0H112l-8-3.67a1,1,0,0,1-.42-.29,1.07,1.07,0,0,1-.15-.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.81,253.09a4.63,4.63,0,0,1,.3-.8,1.45,1.45,0,0,1,.58-.62l2.66-1.54a.24.24,0,0,1,.31,0,.54.54,0,0,1,.12.39,1.13,1.13,0,0,1,0,.3L118,279.46a3.22,3.22,0,0,1-.28.78,1.49,1.49,0,0,1-.59.65l-2.6,1.5a.24.24,0,0,1-.31,0,.54.54,0,0,1-.13-.4,1.24,1.24,0,0,1,0-.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.41,257.72a2.1,2.1,0,0,1-.15.84,5.28,5.28,0,0,1-.43.78l-7.94,12.84a1.16,1.16,0,0,1-.13.15l-.09.07a.24.24,0,0,1-.3,0,.54.54,0,0,1-.12-.39v-5a2.13,2.13,0,0,1,.23-1,7.31,7.31,0,0,1,.41-.66l3.47-5.37-3.47-1.32a1.77,1.77,0,0,1-.41-.21c-.15-.11-.23-.37-.23-.77v-5a1.17,1.17,0,0,1,.12-.52.79.79,0,0,1,.3-.36l.09,0h.13l7.94,3.67a.8.8,0,0,1,.58.95Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chart--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--chart--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.62,202l41.52-24c.67-.39,1.22-.08,1.22.7v36.14a2.72,2.72,0,0,1-1.22,2.11l-41.52,24c-.67.39-1.22.08-1.22-.7V204.06A2.72,2.72,0,0,1,92.62,202Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speach-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.4,183.58,96,204.6a3,3,0,0,0-1.35,2.33V240.7A3,3,0,0,0,96,243l2.56,1.45a3,3,0,0,0,2.7,0l36.43-21a3,3,0,0,0,1.35-2.33V187.34a2.94,2.94,0,0,0-1.36-2.32l-2.56-1.45A3,3,0,0,0,132.4,183.58Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.24,244.46a3.08,3.08,0,0,1-2.7,0L96,243a2.9,2.9,0,0,1-1.36-2.31V206.93a2.82,2.82,0,0,1,.43-1.38l5.24,3a2.7,2.7,0,0,0-.4,1.33v33.77C99.89,244.46,100.44,244.92,101.24,244.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139,187.09c-.11-.67-.66-.92-1.33-.53l-36.43,21a2.77,2.77,0,0,0-.95,1l-5.25-3a2.73,2.73,0,0,1,.93-1l36.44-21a3,3,0,0,1,2.69,0l2.56,1.45A3,3,0,0,1,139,187.09Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M137.67,186.56l-36.43,21a3,3,0,0,0-1.35,2.33v33.77c0,.86.6,1.21,1.35.78l36.43-21a3,3,0,0,0,1.35-2.33V187.34C139,186.48,138.41,186.13,137.67,186.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.94,187.65v33.46a1.94,1.94,0,0,1-.81,1.4L101,243.37V209.91a2,2,0,0,1,.8-1.4l36.17-20.86m.33-1.27a1.27,1.27,0,0,0-.6.18l-36.43,21a3,3,0,0,0-1.35,2.33v33.77c0,.61.3,1,.74,1a1.28,1.28,0,0,0,.61-.18l36.43-21a3,3,0,0,0,1.35-2.33V187.34c0-.61-.31-1-.75-1Z",
    style: {
      fill: "#3B3355"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--bar-graph--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "129.06 222.79 129.05 199.38 126.97 198.17 126.97 221.58 129.06 222.79",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.06 222.79 129.05 199.38 126.97 198.17 126.97 221.58 129.06 222.79",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.06 222.79 135.12 219.29 135.12 195.88 129.05 199.38 129.06 222.79",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.12 195.88 133.03 194.67 126.97 198.17 129.05 199.38 135.12 195.88",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.12 195.88 133.03 194.67 126.97 198.17 129.05 199.38 135.12 195.88",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.12,195.88l-6.07,3.41L127,198.17l2,1.34c-.05.68,0,22.58.08,23.28.1-.7.13-22.64.09-23.3Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.69 229.35 117.69 210.55 115.6 209.34 115.6 228.14 117.69 229.35",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.69 229.35 117.69 210.55 115.6 209.34 115.6 228.14 117.69 229.35",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.69 229.35 123.75 225.85 123.75 207.05 117.69 210.55 117.69 229.35",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "117.69 229.35 123.75 225.85 123.75 207.05 117.69 210.55 117.69 229.35",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.75 207.05 121.66 205.84 115.6 209.34 117.69 210.55 123.75 207.05",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "123.75 207.05 121.66 205.84 115.6 209.34 117.69 210.55 123.75 207.05",
    style: {
      fill: "#fff",
      opacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.77,210.59l6-3.54-6.06,3.41c-.66-.38-2.09-1.12-2.09-1.12s1.33.85,2,1.25c0,.71,0,18,.08,18.76C117.73,228.63,117.79,211.28,117.77,210.59Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.32 235.91 106.32 220.13 104.23 218.92 104.23 234.71 106.32 235.91",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.32 235.91 106.32 220.13 104.23 218.92 104.23 234.71 106.32 235.91",
    style: {
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.32 235.91 112.38 232.41 112.38 216.63 106.32 220.13 106.32 235.91",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.32 235.91 112.38 232.41 112.38 216.63 106.32 220.13 106.32 235.91",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.38 216.63 110.3 215.42 104.23 218.92 106.32 220.13 112.38 216.63",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.38 216.63 110.3 215.42 104.23 218.92 106.32 220.13 112.38 216.63",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.38,216.63,106.32,220l-2.09-1.12,2,1.31s0,15.25.08,15.68c.09-.43.09-15.67.09-15.67Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.38,65.44a25.33,25.33,0,0,1-6.81,17.32l-2.09,2a25.31,25.31,0,0,1-35.76-35.59l2-2.1a25.31,25.31,0,0,1,42.67,18.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407,38a27.48,27.48,0,0,0-4.45,54.58l3.1,8a1.59,1.59,0,0,0,3,0l3.07-8A27.47,27.47,0,0,0,407,38Zm25.39,27.42a25.33,25.33,0,0,1-6.81,17.32l-2.09,2a25.31,25.31,0,0,1-35.76-35.59l2-2.1a25.31,25.31,0,0,1,42.67,18.38Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.38,65.44a25.33,25.33,0,0,1-6.81,17.32l-2.09,2a25.31,25.31,0,0,1-35.76-35.59l2-2.1a25.31,25.31,0,0,1,42.67,18.38Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M422,76.09a.47.47,0,0,0,0-.53l-2.09-2.65a2.12,2.12,0,0,1-.26-2.15s0,0,0,0h0a2.13,2.13,0,0,1,1.7-1.33L424.7,69a.45.45,0,0,0,.39-.36,17.42,17.42,0,0,0,.27-3.12,18.53,18.53,0,0,0-.26-3.13.46.46,0,0,0-.38-.36l-3.35-.39a2.1,2.1,0,0,1-1.69-1.31l0-.07a2.09,2.09,0,0,1,.27-2.13l2.1-2.64a.44.44,0,0,0,0-.53,17.4,17.4,0,0,0-4.4-4.41.45.45,0,0,0-.52,0l-2.64,2.09a2.16,2.16,0,0,1-2.16.27l0,0A2.14,2.14,0,0,1,411,51.2l-.37-3.36a.45.45,0,0,0-.36-.38,18.22,18.22,0,0,0-6.25,0,.47.47,0,0,0-.36.39l-.39,3.35a2.11,2.11,0,0,1-1.33,1.7l0,0a2.14,2.14,0,0,1-2.15-.27l-2.63-2.1a.47.47,0,0,0-.53,0,17.81,17.81,0,0,0-4.42,4.41.44.44,0,0,0,0,.52l2.09,2.65a2.12,2.12,0,0,1,.26,2.14.14.14,0,0,0,0,.06,2.12,2.12,0,0,1-1.7,1.31l-3.37.38a.43.43,0,0,0-.37.36,18,18,0,0,0,0,6.22.41.41,0,0,0,.38.36l3.36.4a2.16,2.16,0,0,1,1.7,1.34s0,0,0,0a2.07,2.07,0,0,1-.26,2.14l-2.1,2.65a.44.44,0,0,0,0,.52,17.48,17.48,0,0,0,4.41,4.42.44.44,0,0,0,.52,0l2.64-2.09a2.11,2.11,0,0,1,2.16-.25h0a2.12,2.12,0,0,1,1.32,1.7l.37,3.35a.44.44,0,0,0,.36.39,17.58,17.58,0,0,0,3.12.28,18.89,18.89,0,0,0,3.13-.26.48.48,0,0,0,.36-.39l.39-3.35a2.12,2.12,0,0,1,1.32-1.7h.05a2.12,2.12,0,0,1,2.15.26L417,80.47a.44.44,0,0,0,.52,0A18.11,18.11,0,0,0,422,76.09ZM407,74.75a9.26,9.26,0,1,1,9.26-9.23A9.25,9.25,0,0,1,407,74.75Z",
    style: {
      fill: "#3B3355"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M378.47,360.31c.4,11.51.68,22.71.5,29.46,0,.63,4.53,3.46,8.8,2.73s5.41-2.23,5.41-2.68c0-1.56,1.47-3.79,1.55-5.34a198.44,198.44,0,0,1,2.78-24.17Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.66,365.47l-19.53-1.64c2,9.73,4.2,19.83,5.76,26.65a38,38,0,0,0,1.76,6c.93,4.4,11.49,4.93,13.6-2.09l-.46-6C446.53,382.89,446,373.72,445.66,365.47Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.68,411.44c-.26,0-.46,3,1.09,4.17,1.79,1.34,6.92,3.38,13.4,2.07s8.22-2.76,10.68-5.14,4.71-4.84,7.62-5.71c2.71-.8,6.82-2.2,7.64-3.11s.43-4.69.43-4.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.87,382.83a1.17,1.17,0,0,1,1.17.82c.27,1,.71,4,1.26,5.72a43.17,43.17,0,0,1,1.21,11c-.23,2-5.83,3.57-8.61,4.87a27.12,27.12,0,0,0-7.66,5.64,20.17,20.17,0,0,1-11.78,5.28c-5,.33-10.85-.91-12.32-3.15-1.81-2.79-2.25-5.55,5-9.55,1.37-.76,5.56-3.63,7.18-4.82a32.67,32.67,0,0,0,4.92-4.33,25.46,25.46,0,0,0,1.78-2.11,6.28,6.28,0,0,0,.89-2.19c.34-1.41.05-2.89.18-4.34a.58.58,0,0,1,.43-.6,8.83,8.83,0,0,1,3.65-.45,14.94,14.94,0,0,1,3.75.57,3.06,3.06,0,0,1,1.77,1,2.75,2.75,0,0,1,.44,1.38,9.89,9.89,0,0,0,.14,1.44.87.87,0,0,0,.23.47c.27.24.66,0,.86-.21a18.82,18.82,0,0,0,1.85-2.57c.32-.46,1.89-.85,2.31-1.23a12.56,12.56,0,0,0,1.22-.92C395.16,384,394.89,383.43,394.87,382.83Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.24,410.85a39.13,39.13,0,0,1,3.28-2.92h0s-7.75,3.72-11.48,1.54c-2.4-1.4-1.44-3.38-1.43-4s-5.82-2.82-8.07-2.92h0c-.59.38-1.09.7-1.41.87-7.24,4-6.8,6.76-5,9.55,1.47,2.24,5.72,3.78,12.24,3.32A20.85,20.85,0,0,0,382.24,410.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.1,403.66c-4.52,2.19-2.48,2.92-1.16,3s7.62-4.15,12.13-8.27c4.7-4.3,8.75-8.77,10.49-10.35.66-.59,1.35-1.31,2-2-.2-1-.36-1.94-.49-2.42a1.65,1.65,0,0,0-1.28-1l0,1.87a3.62,3.62,0,0,1-1.31.79,6,6,0,0,0-2.22,1.36,18.82,18.82,0,0,1-1.85,2.57C385.66,394.65,377.62,401.47,373.1,403.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.22,406a.46.46,0,0,0,.29-.13.47.47,0,0,0,0-.65,11.1,11.1,0,0,0-8.77-2.76.46.46,0,0,0-.37.54.45.45,0,0,0,.54.37,10.27,10.27,0,0,1,7.92,2.48A.46.46,0,0,0,372.22,406Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.13,403.39a.5.5,0,0,0,.28-.12.46.46,0,0,0,0-.65,11.09,11.09,0,0,0-8.7-3,.45.45,0,0,0-.38.52.46.46,0,0,0,.52.39,10.32,10.32,0,0,1,7.87,2.66A.49.49,0,0,0,376.13,403.39Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.7,400.51a.44.44,0,0,0,.28-.12.46.46,0,0,0,0-.66,11.06,11.06,0,0,0-8.76-2.75.45.45,0,0,0-.37.53.46.46,0,0,0,.53.38,10.28,10.28,0,0,1,7.93,2.48A.48.48,0,0,0,379.7,400.51Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.85,397.92a.46.46,0,0,0,.29-.11.47.47,0,0,0,.05-.65,11.08,11.08,0,0,0-8.64-3.13.46.46,0,0,0-.4.52.46.46,0,0,0,.52.39,10.31,10.31,0,0,1,7.82,2.82A.46.46,0,0,0,382.85,397.92Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.22,394.89a.55.55,0,0,0,.29-.11.46.46,0,0,0,.05-.65c-1.88-2.23-6-3.6-9.44-3.11a.46.46,0,1,0,.13.91c3.08-.43,6.93.82,8.61,2.79A.44.44,0,0,0,386.22,394.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.77,420.43c.33,4.54,1.07,7.54,2.72,10.18s4.7,3.44,7.77,2.62,7-3,7.81-6.9.62-6.61-.14-10.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.79,388.41c1.08.33,1.43,6.55,2.25,12.64.88,6.54,2.06,8.5,2.83,13.85.89,6.12.48,8.18-1.61,11.92s-9.66,7.47-13.48,2.22c-3.11-4.29-3.19-8.4-3-14.53a126.77,126.77,0,0,0-.25-14.58c-.31-4.59-2.74-8.92-1.65-9.45-.2.1.72,3.17.8,3.44a5.62,5.62,0,0,0,.69,1.68c.61.85.88-.55.87-1.08,0-.9-.32-1.62.37-2.39a5.3,5.3,0,0,1,1.89-1.11,12.19,12.19,0,0,1,2.3-.69,24.19,24.19,0,0,1,4.89-.34,2.34,2.34,0,0,1,1.89.76,1.3,1.3,0,0,1,.19.48c.13.6.07,1.22.21,1.82,0,.17.11.6.27.7s.42.05.43-.07S446.93,389.48,446.79,388.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.58,412.81c.14.88.83,6.39-.75,7.47s-2.73-3.42-2.73-3.42-4.06-1.19-9.92,1.47c.32.95-.55,4.09-2.17,3.45s-2.23-6.65-2.24-6.74c-.16,5.87,0,9.84,3,14,3.82,5.25,11.38,1.51,13.48-2.22s2.5-5.8,1.61-11.92C451.78,414.29,451.7,413.36,451.58,412.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.65,417.26c.05,2.21,2,1.42,2.28-1.7.39-4.68-.83-9.12-.89-14.51-.82-6.09-1-12.55-2.25-12.64.06,1.06-.1,5.27-.1,5.27.46,4.57,1.73,9.89,1.61,14.6C448.2,412.43,447.59,415,447.65,417.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.86,418.26c-.44-2.17-1.16-2.78-1.65-6.9s-2.87-11.48-3.8-15.94c-.26-1.38-1.51-4.89-1.52-4.94-.79.4,0,2.95.66,5.7s1.11,4.45,1.54,7.1c1.16,5.25,1.4,10.86,2.16,13.89S439.31,420.43,438.86,418.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.36,418.38a.49.49,0,0,0,.17-.06,15,15,0,0,1,9.76-1.14.47.47,0,0,0,.23-.92,15.67,15.67,0,0,0-10.43,1.24.45.45,0,0,0-.19.63A.46.46,0,0,0,438.36,418.38Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,414a.42.42,0,0,0,.16,0c.05,0,5.65-2.7,11.39-1.45a.47.47,0,0,0,.55-.36.46.46,0,0,0-.36-.56,20.42,20.42,0,0,0-12,1.52.47.47,0,0,0-.21.63A.46.46,0,0,0,437,414Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.16,408.89a.47.47,0,0,0,.4-.32.48.48,0,0,0-.3-.6c-5.72-1.85-13.16.92-13.39,1a.47.47,0,0,0-.19.64.47.47,0,0,0,.63.18c.06,0,7.34-2.7,12.66-1A.41.41,0,0,0,449.16,408.89Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.19,404.93a.48.48,0,0,0,.39-.31.47.47,0,0,0-.29-.6c-6.29-2.16-12.67,1.36-12.89,1.5a.47.47,0,0,0-.15.64.47.47,0,0,0,.65.15c.05,0,6.23-3.41,12.08-1.4A.5.5,0,0,0,448.19,404.93Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.74,400.09a.47.47,0,0,0,.1-.91c-5.89-2.11-12.73,1.49-13,1.64a.46.46,0,0,0-.17.64.47.47,0,0,0,.65.16c.05,0,6.69-3.51,12.16-1.55A.55.55,0,0,0,447.74,400.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.89,287.1,401,316.45a92.1,92.1,0,0,1,1.06,17.25c-.42,8.47-4.22,33-6.07,42a18.74,18.74,0,0,1-18.39.44s-1.84-49.43-2.6-61.31,1-60.09,1.61-78.93l57.79.17s1.15,10.14,2.17,25.28S440,317.05,440,317.05c6.26,18,5.67,29.84,6.77,63.49a17.48,17.48,0,0,1-17.13,2s-9.1-33.06-12.61-46.46c-1.67-6.4-7.75-34.22-11.14-49",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.77,265.27l-1.66,23.11c-.1,3.7-.92,11.78-1,15.47s-.18,7.38,0,11,1.94,33.58,1.64,41c-1.09-8.21-2.89-33.47-3.35-40.91-.18-7.47.67-15.93,1.66-26.65S380.84,272.61,381.77,265.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,261.32c2.9,12.12,7.66,43.45,8.74,51.83s9.07,41.43,9.89,49.88c-1.48-8.36-10.42-41.22-11.59-49.66S417.84,276.66,416,261.32Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.94,264.15l4.95,23L401,316.45l2-24.55-5.37-25.1s-10.1-3-12.73-13.26C390.09,261.8,400.94,264.15,400.94,264.15Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Top--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.71,197.05c2.33,1.71,4.78,4.43,8.75,7.48s10,8.44,15.77,11.6,8.57,4.43,15.36-3.07c8.61-9.51,17-22.73,17-22.73l-1-26.86c-5.86,2-9.15,5.24-12.63,10.95-6.56,10.75-11,17.69-14.81,23.9,0,0-16.88-9.23-19.09-10.71a8.86,8.86,0,0,1-3.53-4.63,42.78,42.78,0,0,0-1.82-4.65c-.72-1.61-1-2.22-1.83-4.24s-1.52-5.46-1.79-6.21c-.5-.85-1.78-.74-2.81,1.4a8.3,8.3,0,0,0-.37,4.16c.09,1.25.51,2.76.14,3s-2.19-.65-4-1-3.42-1.11-5.39-.47a2.35,2.35,0,0,0-1.54,3.16,2.93,2.93,0,0,0,1.09,1.17,2.53,2.53,0,0,0-1.9.64,2.77,2.77,0,0,0,0,3.49,1.56,1.56,0,0,0-1.49,1.41c-.18,1.18,0,2.34,1.17,2.78,0,0-1,.25-1,.82a2.78,2.78,0,0,0,1,2.57,9.21,9.21,0,0,0,3.39.71s.18.42,1.32,1a28.19,28.19,0,0,0,3.8,1.92C325,195.11,327.85,195.68,329.71,197.05Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.13,198.32A13.07,13.07,0,0,1,364,206.8a10,10,0,0,0-5.18-9.67Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.57,163.34a18.66,18.66,0,0,0-8.63,5.39c-2.41,2.57-6.64,9.81-9.17,13.84s-5.25,8.27-5.25,8.27.19,10.2,13.24,15.24L387,190.62Z",
    style: {
      fill: "#3B3355"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.5,188.83a1,1,0,0,1-.22.87,7.27,7.27,0,0,1-.82.85,5.48,5.48,0,0,1-.44.4,2.3,2.3,0,0,1-.49.27l-1.15.45a5.31,5.31,0,0,0,1.25-.13,1.55,1.55,0,0,0,.62-.27,3.9,3.9,0,0,0,.51-.4,5.29,5.29,0,0,0,.81-1,1.37,1.37,0,0,0,.16-.66.81.81,0,0,0-.15-.4,6,6,0,0,0,.94-.38,3.2,3.2,0,0,0,1.29-.94,3,3,0,0,0,.25-.78,1.22,1.22,0,0,0,0-.27l.35-.53a6.89,6.89,0,0,0,1.75,2.78,8.18,8.18,0,0,0,3.4,2.11,7.16,7.16,0,0,1-3.62-8.79s.06,0,.08,0a1.07,1.07,0,0,0,.37-.47,1.52,1.52,0,0,0,0-1.11,3.36,3.36,0,0,0-.52-.9,5.82,5.82,0,0,0-3.43-1.86,3,3,0,0,0-.5-.7,5.61,5.61,0,0,0-.7-.59,5.43,5.43,0,0,1,.62.65,2.73,2.73,0,0,1,.44.75l0,.05h.05a6.07,6.07,0,0,1,3.2,1.93,1.65,1.65,0,0,1,.42,1.59c-.14.29-.25.37-.56.33s-.63-.09-.95-.13c-.67-.08-1.32-.07-2-.13a8,8,0,0,1-1.85-.44c-.6-.22-1.18-.5-1.77-.78a14.15,14.15,0,0,1-1.71-.93,15.9,15.9,0,0,0,3.37,2,6.66,6.66,0,0,0,1.92.52c.66.08,1.32.08,1.94.17l.38.06a1.2,1.2,0,0,1,.44.75,1.33,1.33,0,0,1-.63,1.31,8.11,8.11,0,0,1-1.4.84,4.62,4.62,0,0,1-1.54.4,11.18,11.18,0,0,1-3.14-.89c-1.06-.37-2.12-.73-3.2-1,1,.49,2.05.93,3.08,1.37.51.22,1,.42,1.57.62a4.79,4.79,0,0,0,1.7.37,4.65,4.65,0,0,0,1.06-.23,1.52,1.52,0,0,1,.88.54.72.72,0,0,1,.15.61,2,2,0,0,1-.26.65,3.25,3.25,0,0,1-1.18.76,3.05,3.05,0,0,1-1.35.39,5.62,5.62,0,0,1-1.41-.38,8.83,8.83,0,0,0-1.52-.28c-1-.12-2-.21-3-.23,1,.2,2,.37,3,.56a13.49,13.49,0,0,1,1.46.33,5.36,5.36,0,0,0,1.51.44A2.25,2.25,0,0,0,321.5,188.83Zm3.54-6.76,0,0h0Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--chest--inject-2",
    d: "M416.23,160.25c9,2,11.66,2.84,15.91,3.81,0,0,8.8,8.14,3.62,37.29a124.3,124.3,0,0,0-1.39,21.5c.14,6.47.41,13.51.57,18,0,0-10,9.78-35.06,7.4-19.67-1.86-23.56-9-23.56-9s.66-27.1.66-42.1c0-23.95,3.2-29.45,8.54-33.7.7-.43,14-2.65,14-2.65Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.18,112.27c9.58-2.28,16.41,1.39,20.46,6.35,4.05,0,6.39,3.18,7,7.16,2.16,13.39-8.53,20.56-10.11,27.17l-31.84-23.34C382.08,124.83,384.57,115.27,397.18,112.27Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.6,116.54l-5.28,2.17a3,3,0,0,0,3.85,1.52A2.71,2.71,0,0,0,422.6,116.54Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418,113.25l-.73,5.55a3,3,0,0,0,3.28-2.5A2.74,2.74,0,0,0,418,113.25Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.38,118.3c-4.05-5-10.62-8.31-20.2-6-12.61,3-15.1,12.56-14.47,17.34l6.88,4.89,11.64-9.81C402.87,121.36,413.36,117.94,417.38,118.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.23,124.69c1.21-1,3-1.54,5.44,0a7,7,0,0,1,2.52,3.11,16.21,16.21,0,0,1,1.1,5.13c.25,1.92,1.49,6.35,4.49,4.8.88-.46,1.32-1.42,2.08-2,2.4-1.82,5.9-1.41,7.25,1.33a7.21,7.21,0,0,1-2.55,9.33c-4.12,2.31-5.8,0-5.8,0l1.3,15.2c-2.53,4.91-9.26,8.62-16.06,8.34s-5.36-3.78-3.05-6.51l-.53-5.89a19.56,19.56,0,0,1-5.62-.35c-4.2-1-6.27-4.73-7.25-8.6-1.13-4.44-1.25-11.64-1.1-16.34a31,31,0,0,1,.44-3.86C387,123.65,398,119.58,401.23,124.69Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.82 133 394.66 144.09 389.09 142.06 395.82 133",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.56,145.23l-5.73,2.21a3,3,0,0,0,3.94,1.8A3.14,3.14,0,0,0,400.56,145.23Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.77,149.24a2.54,2.54,0,0,1-.37.1,2.75,2.75,0,0,1,2.34-3.06A3.13,3.13,0,0,1,398.77,149.24Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.69,134a4.91,4.91,0,0,0-1.36-.38,3.71,3.71,0,0,0-1.37,0,4.32,4.32,0,0,0-1.37.48s-.06.12,0,.11c.37-.06.7-.14,1.24-.2h.43a1.89,1.89,0,0,0-.67,1c-.27,1,.41,1.23,1.35,1.48s1.78.39,2.06-.56a1.82,1.82,0,0,0-.17-1.4l.32.13c.18.08.55.24.58.27s.09-.1.06-.14A3,3,0,0,0,389.69,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.1,134c.06,0,0-.09,0-.11a4.77,4.77,0,0,0-1.36-.52,3.71,3.71,0,0,0-1.37-.05,4.92,4.92,0,0,0-1.37.34,3.28,3.28,0,0,0-1.13.73s0,.18.06.15.4-.18.59-.25l.32-.12a1.84,1.84,0,0,0-.21,1.39c.25,1,1.09.84,2,.61s1.64-.47,1.4-1.43a1.86,1.86,0,0,0-.64-1h.43C403.41,133.8,403.73,133.89,404.1,134Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401,129.4l3.51,2a2,2,0,0,0-.79-2.76A2,2,0,0,0,401,129.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.42,157.53a37.32,37.32,0,0,0,8.86-2c3.37-1.45,4.82-2.56,6.38-6.55a9.43,9.43,0,0,1-2.32,5.85c-3.85,3.9-12.73,4.64-12.73,4.64Z",
    style: {
      fill: "#f0997a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.23,124.69c.46-1-.34-2.82-1.19-3.41a4.48,4.48,0,0,0-3.67-.29c-1.81.72-2.2,2.73-2.66,4.34a10.68,10.68,0,0,1-1.22,3.13,5.23,5.23,0,0,1-4.36,2.77,4.77,4.77,0,0,0,1.21-4.09c-1.5,1.77-4.34,4-6.69,4.51-1.63.34-2.46-.4-2.86-1.93-1.06-4,.5-9,3.19-12.12a13.14,13.14,0,0,1,1.17-1.19c5.61-5.06,14.94-7.64,22.68-7.39,4.35.14,10.77,3.19,10.55,9.28C413.35,118.05,402.78,121.32,401.23,124.69Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Tablet--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.5,201.47h0l1.41-1.32v0a1.65,1.65,0,0,1,1.49-.22l43.32,10a5.82,5.82,0,0,1,3.67,3.17L414,245.42a1.51,1.51,0,0,1-.14,1.68h0l-1.45,1.35h0a1.63,1.63,0,0,1-1.5.23l-43.32-10a5.84,5.84,0,0,1-3.68-3.17l-12.64-32.27A1.43,1.43,0,0,1,351.5,201.47Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,212.14a5.69,5.69,0,0,1,1.93,2.33l12.65,32.26a1.58,1.58,0,0,1-.09,1.64l1.36-1.26h0a1.49,1.49,0,0,0,.15-1.68l-12.65-32.28a5.57,5.57,0,0,0-1.78-2.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.6,246.73,400,214.47a5.77,5.77,0,0,0-3.67-3.17l-43.32-10c-1.48-.34-2.23.53-1.67,1.94l12.64,32.27a5.84,5.84,0,0,0,3.68,3.17l43.32,10C412.41,249,413.15,248.14,412.6,246.73Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.21,221.33l-2.37-6a1.07,1.07,0,0,0-.69-.59l-3-.69c-.28-.06-.42.1-.31.37.46,1.18,1.9,4.85,2.37,6a1.09,1.09,0,0,0,.68.6l3,.68C400.17,221.76,400.31,221.59,400.21,221.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.75,216.76A2.71,2.71,0,0,0,396,215.3c-.71-.16-1.08.22-.83.87a2.74,2.74,0,0,0,1.75,1.46C397.63,217.79,398,217.4,397.75,216.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.91,219.81a2.73,2.73,0,0,0-1.75-1.46c-.71-.17-1.09.22-.84.86a2.73,2.73,0,0,0,1.75,1.46C398.79,220.84,399.16,220.45,398.91,219.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.06,227.69l.68,1.73a42.68,42.68,0,0,1-7.5,1.22c-.85,0-4.06-1.51-6.68-2.19s-4.31.88-2.95,1.93a17.27,17.27,0,0,0,2.28,1.59c-1.1,1.1-1.86,2.12.35,4a2.94,2.94,0,0,0,.94,3.26,28.07,28.07,0,0,0,7.38,4.67c1.44.55,8.94.06,9.56-.28a46.31,46.31,0,0,0,5.7-4,42.68,42.68,0,0,1,7.57-4.2c2.29-.76,22.61-9.16,26.19-11s9.39-5.76,4.53-9.58-12.35-6.11-18.2-2.32c-4.26,2.75-15,8.7-19.79,11.54a6,6,0,0,1-4.34.89,31.82,31.82,0,0,0-6.75.11Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.37,164.51c9.3,2.66,12.12,4.32,14,9.35,3.1,8.19,10.18,36.21,10.57,43.52.2,3.61-17.16,4.2-17.16,4.2l-2.89-9s-6-20.45-7.36-24.77C428,182.89,426.23,169.24,432.37,164.51Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.91,212.54c3.1-2,8.94-2.29,12.12-1-2.3-2.94-9.29-2.45-12.54-.33Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.89,232c1.06.61,2.09,1.26,3.11,1.92.52.33,1,.68,1.53,1a1.22,1.22,0,0,0,.7.31l.89.1c2.4.17,4.83.17,7.27.37-1.22.12-2.43.18-3.65.22s-2.44,0-3.67-.05c-.3,0-.61-.06-.93-.11a2.24,2.24,0,0,1-.51-.16,3.11,3.11,0,0,1-.42-.27c-.49-.36-1-.71-1.46-1.08C394.78,233.5,393.82,232.76,392.89,232Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.24,236c1,.69,2,1.36,3,2,.52.31,1,.64,1.56.93.26.15.53.31.78.44a3.38,3.38,0,0,0,.8.18c1.18.15,2.4.18,3.61.25s2.43.09,3.65.23a41.71,41.71,0,0,1-7.33.06,3.86,3.86,0,0,1-1-.25,8.85,8.85,0,0,1-.8-.47c-.52-.32-1-.65-1.53-1A24.29,24.29,0,0,1,393.24,236Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.15,240.81c.83.33,1.63.69,2.46,1a12.25,12.25,0,0,0,2.51.61,17.25,17.25,0,0,0,2.6.06,15,15,0,0,1,2.67.16l-2.64.3a10.6,10.6,0,0,1-2.7,0A11.41,11.41,0,0,1,396.15,240.81Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.14,164.06c7.8,2,9.2,3.06,11.77,5.2s3.61,5.74,5.45,12.44S454.59,202,454.59,202a16.12,16.12,0,0,1-9,4.62,22.81,22.81,0,0,1-10.9-.51s-5.45-17.16-6.41-20.26S425.13,168.1,432.14,164.06Z",
    style: {
      fill: "#3B3355"
    }
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.88392ab6260cb6a2ff6387c111989e22.svg";
export { ForwardRef as ReactComponent };